require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/dd219901ef2d49920c9992ddacadd349/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dd219901ef2d49920c9992ddacadd349'] = async function fn_dd219901ef2d49920c9992ddacadd349() {
return (await (async function(euro) {
	var result;

	  if (euro) {
	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
	      style: "currency",
	      currency: "EUR",
	      })
	    result=EUcostFormat.format(euro);

	} else {
	   result = '€ 0,00';
	}

	return result;
})(null))
}

})
define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'gebruiker') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'beheerder') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick *//* content */
}));

define('./pages/afsluitendossier/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var zorgconsumptieplaatsgevonden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  zorgconsumptieplaatsgevonden = (await Backendless.Data.of('zorgconsumptiesdata').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('zorgconsumptiesplaatsgevonden').setPageSize(10)))[0];
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c61e972ea44d60bf24f273727da2add6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'overlijdenplaats')) == null) {
    (function (message) { alert(message) })('De plaats van overlijden dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6692e304a36b8a9803c2d3847aa22a23')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'overlijdenplaatsvoorkeur')) == null) {
    (function (message) { alert(message) })('De plaats van voorkeur overlijden dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'ervareneigenregie')) == null) {
    (function (message) { alert(message) })('Ervaren regie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0242899dafb46f6b8d478a04ba641bb5')), 'display')) == true && !(getObjectProperty(zorgconsumptieplaatsgevonden, 'zorgconsumptiesplaatsgevonden')).length) {
    (function (message) { alert(message) })('De zorgconsumptie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c875480efa6fb25f61c358854144b23f')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'consultatieaangevraagd')) == null) {
    (function (message) { alert(message) })('De consultatie dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47f5aa841115e636e11c0b8315b1ab94')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'tijdigheidsignalering')) == null) {
    (function (message) { alert(message) })('De tijdigheid van de signalering dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('dossiersafgesloten').save( ({ [`datumafsluiten`]: (new Date()),[`overlijdendatum`]: (getObjectProperty(___arguments.context.pageData, 'overlijdendatum')),[`overlijdenplaats`]: (getObjectProperty(___arguments.context.pageData, 'overlijdenplaats')),[`overlijdenplaatsvoorkeur`]: (getObjectProperty(___arguments.context.pageData, 'overlijdenplaatsvoorkeur')),[`betreft`]: (getObjectProperty(___arguments.context.pageData, 'betreft')),[`consultatieaangevraagd`]: (getObjectProperty(___arguments.context.pageData, 'consultatieaangevraagd')),[`consultatieaangevraagdtoelichting`]: (getObjectProperty(___arguments.context.pageData, 'consultatieaangevraagdtoelichting')),[`ervareneigenregie`]: (getObjectProperty(___arguments.context.pageData, 'ervareneigenregie')),[`ervareneigenregietoelichting`]: (getObjectProperty(___arguments.context.pageData, 'ervareneigenregietoelichting')),[`redenafrondingtraject`]: (getObjectProperty(___arguments.context.pageData, 'redenafrondingtraject')),[`tijdigheidsignalering`]: (getObjectProperty(___arguments.context.pageData, 'tijdigheidsignalering')),[`tijdigheidsignaleringtoelichting`]: (getObjectProperty(___arguments.context.pageData, 'tijdigheidsignaleringtoelichting')),[`toegevoegdewaardegoed`]: (getObjectProperty(___arguments.context.pageData, 'toegevoegdewaardegoed')),[`toegevoegdewaardewatbeter`]: (getObjectProperty(___arguments.context.pageData, 'toegevoegdewaardewatbeter')),[`zorgconsumptieplaatsgevonden`]: (getObjectProperty(zorgconsumptieplaatsgevonden, 'zorgconsumptiesplaatsgevonden')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`status`]: 'Afgesloten' }) ));
    await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`status`]: 'Afgesloten' }) );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;await ( async function (message){ alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['lijstzorgconsumptie'] = [];

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('zorgconsumptiesdata').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('zorgconsumptiesdata').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0242899dafb46f6b8d478a04ba641bb5', (await Backendless.Data.of('zorgconsumptiesdata').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/afsluitendossier/components/6a5492165634eb0eb5e47712718d0382/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Contact met of bezoek aan huisartsenpost');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Huisartsenpost' }) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
    ___arguments.context.pageData['zchuisartsenpost'] = true;
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zchuisartsenpost'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Contact met of bezoek aan huisartsenpost') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Huisartsenpost','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/f4a5b349a015c0c36bd8b963721dad1d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'SEH bezoek(en)');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'SEH bezoek(en)' }) );
    ___arguments.context.pageData['zcseh'] = true;
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zcseh'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('SEH bezoek(en)') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','SEH bezoek(en)','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/641f87b8e8d49efd37afaba65ed6ae8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Bezoeken poli');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Bezoek poli' }) );
    ___arguments.context.pageData['zcpoli'] = true;
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zcpoli'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Bezoeken poli') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Bezoek poli','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/e54cd02a9fd683f1578be9228dc76ab6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Ziekenhuisopname(s)');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Ziekenhuisopname(s)' }) );
    ___arguments.context.pageData['zcziekenhuisopname'] = true;
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zcziekenhuisopname'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Ziekenhuisopname(s)') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Ziekenhuisopname(s)','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/22ec5343c1f7df3b90a493fa066f65d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'IC opname');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'IC opname' }) );
    ___arguments.context.pageData['zcicopname'] = true;
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zcicopname'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('IC opname') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','IC opname','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/d602d5f7621a9e6ea811b2b527a98ae6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Chemotherapie');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Chemotherapie' }) );
    ___arguments.context.pageData['zcchemo'] = true;
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zcchemo'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Chemotherapie') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Chemotherapie','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/1a869035b9883d2c9338917cb9546877/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Andere vorm van vermijdbare zorgconsumptie');
    await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Andere zorgconsumptie' }) );
    ___arguments.context.pageData['zcanderevorm'] = true;
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    ___arguments.context.pageData['zcanderevorm'] = false;
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Andere vorm van vermijdbare zorgconsumptie') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumpties').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Andere zorgconsumptie','\''].join('')) );
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/ea82be114b943b7347b972d9b6a2b83c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'ervareneigenregie')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/25669c4cc0da587b23bf6c13d9eb6e5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'ervareneigenregie')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/bf087e321dcfeeb51e2dc97dfd1832e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'consultatieaangevraagd')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/64f5bd173d21980cc3c75549c4f5ac34/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'consultatieaangevraagd')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/5af8e6df52bc828b76a829d7f20d3472/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tijdigheidsignalering')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/5c946c2bd1753cfea6e778e65f27eee3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/4d16e5658656e9329404fb4cc891451e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'overlijdendatum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['overlijdendatum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/a89240e3e29b439e79a3ab4663f293e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/0e9c905dce9e135f1f42dadada95006b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['ervareneigenregietoelichting'] = null;
  ___arguments.context.pageData['tijdigheidsignaleringtoelichting'] = null;
  if ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden') {
    ___arguments.context.pageData['betreft'] = 'De patiënt is overleden';
    var j_list = ['redenafrondingtraject'];
    for (var j_index in j_list) {
      j = j_list[j_index];
      ___arguments.context.pageData[j] = null;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders') {
    ___arguments.context.pageData['betreft'] = 'Het traject is wegens andere omstandigheden afgerond';
    var j_list2 = ['overlijdendatum', 'overlijdenplaats', 'overlijdenplaatsvoorkeur', 'ervareneigenregie', 'ervareneigenregietoelichting', 'tijdigheidsignalering', 'tijdigheidsignaleringtoelichting'];
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      ___arguments.context.pageData[j] = null;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/55bddffd6a210b13fbda14b8fc920cb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'tijdigheidsignalering')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/01831d9f496f2e32ad7d6e0310ac8a6e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/c0c33fa9e71662e8971bedd7615bd2c2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/e3b743aad0426e3c58723b07c33f8305/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/6692e304a36b8a9803c2d3847aa22a23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/c0db2867755bfb151826ec8960d8422c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/646c72c5b7de6d7edd5b6d39fc94eb67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/29d41a59652eeaacbb97e7f21f594a76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/c875480efa6fb25f61c358854144b23f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/d194053794fc16b5b869af9a718d67bf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/a718be75f21c017c86c134785829c408/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/0df9c3bbd3efaa96589f97a94763708d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden' || (getObjectProperty(___arguments.context.pageData, 'visible')) == 'trajectafgerondanders')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/a6ee64fb4431927b86029b52e3291c13/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/47f5aa841115e636e11c0b8315b1ab94/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/ff0f4d725209daf7dd65656962f941b8/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('f4bb3c5d90a70861aa74d5da68f632cf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/258ef383f34f98ef20c5d9a9c8fe64d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('f4bb3c5d90a70861aa74d5da68f632cf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/85f99db98f314e7858497c1978bdde22/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('f4bb3c5d90a70861aa74d5da68f632cf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/e827cea32b4c6db972bb2cc16585c56b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Huisartsenpost' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a146b4da90afd03905214ead91ff832', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Huisartsenpost','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/ed1af70ff367edc79cb9982f340269b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('527a975af1eefdcbc8e2d77a34141194') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/10c5adfb9da9f2d13b77320a08836cfc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('527a975af1eefdcbc8e2d77a34141194') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/a7a491e250993c9291be100c448bc00b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('36bd3ca766fbd01ad23e94b5e0d51361') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/889ebf643d29ade57466b4f1227189d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('36bd3ca766fbd01ad23e94b5e0d51361') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/042a588685ed9a891cd8c6b910983abc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('e73daf4f36de3e731c4309bf8584368e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/dcaf3b96f708f0e91e15a464ebdf7fa7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('e73daf4f36de3e731c4309bf8584368e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/1b8f56587d0a9c0214d53df5b6a1a386/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('e73daf4f36de3e731c4309bf8584368e') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/c5c116177db4080bd9274e64045591a9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('b341bacc17d59339377fdeb6fba59219') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/d8098be2b4fe3845c54eb648b82ba978/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('b341bacc17d59339377fdeb6fba59219') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/7724a5470cad9253b15d3a025683281f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('b341bacc17d59339377fdeb6fba59219') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/083d90189399f12a5c8dcfb86113c05b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('b341bacc17d59339377fdeb6fba59219') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/ab7f957fff021a4a670819c61aa9367f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('b341bacc17d59339377fdeb6fba59219') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/966dbac4472f2ab51a2d3b56754d01f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('194890f781a72993673ebe8f2535a8f6') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/e7d1083647bc3821210d53aaf5282c4a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('194890f781a72993673ebe8f2535a8f6') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/738af66400ecb3153a95d9737a0de6a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('194890f781a72993673ebe8f2535a8f6') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/43c72deea79af294c32a3f79cfebcd9b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('194890f781a72993673ebe8f2535a8f6') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/fcd72a5bbb25f6d251838fbd4f61cf82/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('ff8dc316fae730e817ef1df5bd337843') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/4b120f2d53c9995855db68b2ec5f6c92/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('zorgconsumpties').save( ___arguments.context.getComponentDataStoreByUid('ff8dc316fae730e817ef1df5bd337843') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/db14330cb8bf92f45bdf96fd7181ec1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zcanderevorm')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('AFSLUITEN DOSSIER ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/a1e914fee6e1dc1f0a0da8b6d7eb0699/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Er hebben geen zorgconsumpties plaatsgevonden');
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Er hebben geen zorgconsumpties plaatsgevonden') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'zorgconsumptiesplaatsgevonden': (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossier/components/0242899dafb46f6b8d478a04ba641bb5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0242899dafb46f6b8d478a04ba641bb5', (await Backendless.Data.of('zorgconsumptiesdata').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/9a146b4da90afd03905214ead91ff832/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a146b4da90afd03905214ead91ff832', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Huisartsenpost','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/53da836604dd26c3193a5711bd6adc11/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zchuisartsenpost')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/0dde5a66ea4fbc1ddfe21f5d32f409b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zcanderevorm')) == true) {
    ___arguments.context.pageData['zcanderevorm'] = true;
  } else {
    ___arguments.context.pageData['zcanderevorm'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zcchemo')) == true) {
    ___arguments.context.pageData['zcchemo'] = true;
  } else {
    ___arguments.context.pageData['zcchemo'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zchuisartsenpost')) == true) {
    ___arguments.context.pageData['zchuisartsenpost'] = true;
  } else {
    ___arguments.context.pageData['zchuisartsenpost'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zcicopname')) == true) {
    ___arguments.context.pageData['zcicopname'] = true;
  } else {
    ___arguments.context.pageData['zcicopname'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zcpoli')) == true) {
    ___arguments.context.pageData['zcpoli'] = true;
  } else {
    ___arguments.context.pageData['zcpoli'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zcseh')) == true) {
    ___arguments.context.pageData['zcseh'] = true;
  } else {
    ___arguments.context.pageData['zcseh'] = false;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08'), 'zcziekenhuisopname')) == true) {
    ___arguments.context.pageData['zcziekenhuisopname'] = true;
  } else {
    ___arguments.context.pageData['zcziekenhuisopname'] = false;
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/408f1eae8ec44b4261de2b2e4546fc83/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zcpoli')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/0983fb81827a7856e8a9398e1db8e1c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zcchemo')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/b0de59531ebafad766eb40aadd2e778d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zcseh')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/8cd75b7909af45bb61de7174b5279631/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zcziekenhuisopname')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/c74952080703ca8aee9d7ad4b3f67311/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'zcicopname')) == true && (getObjectProperty(___arguments.context.pageData, 'visible')) == 'patientoverleden')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossier/components/81044453612a240bf8b1277cc0cd44a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81044453612a240bf8b1277cc0cd44a6', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Bezoek poli','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/835b01ef1c479a8b3cf691b2dcf5501f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('835b01ef1c479a8b3cf691b2dcf5501f', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Chemotherapie','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/b7d3aa7b4233c0658cfc49cbc8cfa146/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7d3aa7b4233c0658cfc49cbc8cfa146', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','SEH bezoek(en)','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/b7495d91ef49b9d944938b511a6bf51d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7495d91ef49b9d944938b511a6bf51d', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Ziekenhuisopname(s)','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/a5729768002e18eb5a165e8fdc28aabb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5729768002e18eb5a165e8fdc28aabb', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','IC opname','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/9093e5fea65ed61a739db5bc25735f6f/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9093e5fea65ed61a739db5bc25735f6f', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Andere zorgconsumptie','\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/afsluitendossier/components/2fcbd719e697632d7f3ddadb4f7bb182/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var MIN, lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Huisartsenpost','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a146b4da90afd03905214ead91ff832', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'Huisartsenpost\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/6ac4d114a9de411d5dec6543bf1eff79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Bezoek poli','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81044453612a240bf8b1277cc0cd44a6', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'Bezoek poli\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/c13730bc7a5db4855ba5090330215cb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Chemotherapie','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('835b01ef1c479a8b3cf691b2dcf5501f', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'Chemotherapie\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/e8a6e46136bf8de5fdd501dd0ea5ca53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','SEH bezoek(en)','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7d3aa7b4233c0658cfc49cbc8cfa146', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'SEH bezoek(en)\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/1d06538ebc5d2193dcc2c2b8400a52f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Ziekenhuisopname(s)','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7495d91ef49b9d944938b511a6bf51d', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'Ziekenhuisopname(s)\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/6b5677f76a3ee04385ca0baffb95a811/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','IC opname','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5729768002e18eb5a165e8fdc28aabb', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'IC opname\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/8107cd5779d1b481074685e79b6ca542/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var lastobjectid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  lastobjectid = (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Andere zorgconsumptie','\' '].join(''))).setProperties('objectId').setSortBy('created ASC').setPageSize(100))).slice(-1)[0];
  await Backendless.Data.of('zorgconsumpties').bulkDelete( (['objectId=\'',(getObjectProperty(lastobjectid, 'objectId')),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9093e5fea65ed61a739db5bc25735f6f', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'Andere zorgconsumptie\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/6bb81f1844e3262de368c072280a9fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Bezoek poli' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('81044453612a240bf8b1277cc0cd44a6', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Bezoek poli','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/ec9f95993ba6479cbaf8b9c3644e5f75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Chemotherapie' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('835b01ef1c479a8b3cf691b2dcf5501f', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Chemotherapie','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/731447950dd269bfe0accaae6b21a4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'SEH bezoek(en)' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7d3aa7b4233c0658cfc49cbc8cfa146', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','SEH bezoek(en)','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/6f561004f3d91485347b774a5ab729da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Ziekenhuisopname(s)' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b7495d91ef49b9d944938b511a6bf51d', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Ziekenhuisopname(s)','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/b493714118315601649bb144b3c3c661/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'IC opname' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a5729768002e18eb5a165e8fdc28aabb', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','IC opname','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/30554a6444e78cefb86d5d9814bafc18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('zorgconsumpties').save( ({ 'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'soortzorgconsumptie': 'Andere zorgconsumptie' }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9093e5fea65ed61a739db5bc25735f6f', (await Backendless.Data.of('zorgconsumpties').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\' AND soortzorgconsumptie=\'','Andere zorgconsumptie','\''].join(''))).setSortBy('created ASC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossier/components/ce2c7196e51e7cd2a05ceb4f917ae33e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('zorgconsumptiesdata').save( ___arguments.context.getComponentDataStoreByUid('22030ee383275de18d9710639f7bab08') );
  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')), 'Het is niet duidelijk of er een zorgconsumptie heeft plaatsgevonden');
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`zorgconsumptiesplaatsgevonden`]: (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).indexOf('Het is niet duidelijk of er een zorgconsumptie heeft plaatsgevonden') + 1) - 1), 1);
    await Backendless.Data.of('zorgconsumptiesdata').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`zorgconsumptiesplaatsgevonden`]: (getObjectProperty(___arguments.context.pageData, 'lijstzorgconsumptie')).join(',') }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/afsluitendossieroverige/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0af380977db51f231583a557d11528cf', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['delenaantal', 'status', 'activiteit']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/afsluitendossieroverige/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossieroverige/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/afsluitendossieroverige/components/593d3b7d1be185c64a4655682127601a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'status': 'Afgesloten' }) );
  await Backendless.Data.of('dossiersafgesloten').save( ({ 'datumafsluiten': (new Date()),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'activiteit': (getObjectProperty(___arguments.context.appData, 'activiteit')),'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'status': 'Afgesloten' }) );
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Afsluiten dossier ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/afsluitendossieroverige/components/737afb2ce06aeace44f69e0c7f161d38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'delenaantal')) > 1) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/afsluitendossieroverige/components/a789b70ad70184d8ee68788afd1c2c18/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantal'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantal'));
  ___arguments.context.pageData['status'] = (getObjectProperty(___arguments.context.dataModel, 'status'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/createdossierconsultatietransformatie/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cef2f3b1fcb0aedd0ada861b9f24284')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) == null) {
    (function (message) { alert(message) })('Een korte omschrijving van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9842eebeb11f5b8aa5b9573da8eaa80e')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('De plaats van de activiteit dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('dossiers').save( ({ 'delenaantal': 1,'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),'omschrijvingactiviteit': (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')),'kenmerk': (getObjectProperty(___arguments.context.pageData, 'kenmerk')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'status': 'Actief','activiteit': 'Consultatie transformatie','naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'regio': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regio')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierconsultatietransformatie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultatietransformatie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultatietransformatie/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierconsultatietransformatie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    ___arguments.context.pageData['soort'] = 'Vaste vacatiegelden';
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
    ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
    ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
    ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
    ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
    ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
    ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
    ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden') {
      ___arguments.context.pageData['bedraginput'] = 200;
    } else {
      ___arguments.context.pageData['bedraginput'] = null;
      ___arguments.context.pageData['uren'] = null;
      ___arguments.context.pageData['kilometers'] = null;
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierconsultatietransformatie/components/9842eebeb11f5b8aa5b9573da8eaa80e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setSortBy('gemeentewoonplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossiermdo/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cef2f3b1fcb0aedd0ada861b9f24284')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) == null) {
    (function (message) { alert(message) })('Een korte omschrijving van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2cf313f32eeb4e8ffcd8bd623f9a20ff')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('De plaats van de activiteit dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('dossiers').save( ({ 'delenaantal': 1,'gemeentewoonplaats': (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),'omschrijvingactiviteit': (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')),'kenmerk': (getObjectProperty(___arguments.context.pageData, 'kenmerk')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'status': 'Actief','activiteit': 'MDO','naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'regio': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regio')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiermdo/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiermdo/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiermdo/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiermdo/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    ___arguments.context.pageData['soort'] = 'Vaste vacatiegelden';
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
    ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
    ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
    ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
    ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
    ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
    ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
    ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden') {
      ___arguments.context.pageData['bedraginput'] = 200;
    } else {
      ___arguments.context.pageData['bedraginput'] = null;
      ___arguments.context.pageData['uren'] = null;
      ___arguments.context.pageData['kilometers'] = null;
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossiermdo/components/2cf313f32eeb4e8ffcd8bd623f9a20ff/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setSortBy('gemeentewoonplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4ef69b103c86cb80b4c61e97769a98c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')) == null) {
    (function (message) { alert(message) })('De woonplaats van de patiënt dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('49e7e6e523b6fa2ef5e1edfd2b11f7a1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'verwijzer')) == null) {
    (function (message) { alert(message) })('De verwijzer dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'opstarttraject')) == null) {
    (function (message) { alert(message) })('Start traject dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitstart')) == null) {
    (function (message) { alert(message) })('Complexiteit bij start palliatief traject dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59d287c46ed9b00cb1626701b6dc849e')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschat')) == null) {
    (function (message) { alert(message) })('Door wie is de complexiteit ingeschat dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47c1362b00419b642796f8dbdb277a66')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschatanders')) == null) {
    (function (message) { alert(message) })('Door wie is de complexiteit ingeschat dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d2087aea4615262ec4f30f8a444309d1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'optzp')) == null) {
    (function (message) { alert(message) })('Wordt er aan toekomstige zorgplanning gedaan dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('dossiers').save( ({ [`delenaantal`]: 1,[`oppatientid`]: (getObjectProperty(___arguments.context.pageData, 'oppatientid')),[`kenmerk`]: (getObjectProperty(___arguments.context.pageData, 'kenmerk')),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`verwijzer`]: (getObjectProperty(___arguments.context.pageData, 'verwijzer')),[`opstarttraject`]: (getObjectProperty(___arguments.context.pageData, 'opstarttraject')),[`opcomplexiteitstart`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitstart')),[`opcomplexiteitingeschat`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschat')),[`opcomplexiteitingeschatanders`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschatanders')),[`optzp`]: (getObjectProperty(___arguments.context.pageData, 'optzp')),[`centra`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`status`]: 'Actief',[`activiteit`]: 'Ondersteuning patiënt',[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ;await ( async function (message){ alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    ___arguments.context.pageData['soort'] = 'Vaste vacatiegelden';
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
    ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
    ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
    ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
    ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
    ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
    ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
    ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden') {
      ___arguments.context.pageData['bedraginput'] = 200;
    } else {
      ___arguments.context.pageData['bedraginput'] = null;
      ___arguments.context.pageData['uren'] = null;
      ___arguments.context.pageData['kilometers'] = null;
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/c3e7843e2aaa037673a359271e2e32c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschat')) == 'Anders' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/47c1362b00419b642796f8dbdb277a66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschat')) == 'Anders' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/59d287c46ed9b00cb1626701b6dc849e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value != 'Anders') {
    ___arguments.context.pageData['opcomplexiteitingeschatanders'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'opstarttraject'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['opstarttraject'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/c4ef69b103c86cb80b4c61e97769a98c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gemeentewoonplaats').find(Backendless.DataQueryBuilder.create().setSortBy('gemeentewoonplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'gemeentewoonplaats')),'label': (getObjectProperty(item, 'gemeentewoonplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossierondersteuningpatient/components/49e7e6e523b6fa2ef5e1edfd2b11f7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('verwijzer').find(Backendless.DataQueryBuilder.create().setSortBy('verwijzer ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'verwijzer')),'label': (getObjectProperty(item, 'verwijzer')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/createdossiersupervisie/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7cef2f3b1fcb0aedd0ada861b9f24284')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) == null) {
    (function (message) { alert(message) })('Een korte omschrijving van de activiteit dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('dossiers').save( ({ 'delenaantal': 1,'omschrijvingactiviteit': (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')),'kenmerk': (getObjectProperty(___arguments.context.pageData, 'kenmerk')),'centra': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centra')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'status': 'Actief','activiteit': 'Supervisie','naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'regio': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regio')) }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userdossiers', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/createdossiersupervisie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiersupervisie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiersupervisie/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/createdossiersupervisie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    ___arguments.context.pageData['soort'] = 'Vaste vacatiegelden';
    ___arguments.context.pageData['uren'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['bedraginput'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ [`uren`]: (getObjectProperty(parameters, 'auren')),[`kilometers`]: (getObjectProperty(parameters, 'akilometers')),[`bedrag`]: (getObjectProperty(parameters, 'abedrag')),[`betreft`]: (getObjectProperty(parameters, 'abetreft')),[`omschrijving`]: (getObjectProperty(parameters, 'aomschrijving')),[`bedragtitel`]: (getObjectProperty(parameters, 'bedragtitel')),[`bedragomschrijving`]: (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
    ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
    ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
    ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
    ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
    ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
    ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
    ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
    if ((getObjectProperty(___arguments.context.pageData, 'soort')) == 'Vaste vacatiegelden') {
      ___arguments.context.pageData['bedraginput'] = 200;
    } else {
      ___arguments.context.pageData['bedraginput'] = null;
      ___arguments.context.pageData['uren'] = null;
      ___arguments.context.pageData['kilometers'] = null;
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dashboardpzcoach/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpzcoach/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dashboardpzcoach/components/d6dc1706cc12ee1ff59d37b5e4f5a9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var URL2;


  URL2 = 'https://lookerstudio.google.com/embed/reporting/e98e9cd2-2b96-4e4c-bbd1-8a85adc718e7/page/nP6tD';

  return URL2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/dashboardpzcoach/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/declaratiesindienen/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['actief = 1','AND rol LIKE\'%',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'%\''].join(''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['werkminuten'] = null;
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['betreft'] = null;
  ___arguments.context.pageData['omschrijving'] = null;
  parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ 'uren': (getObjectProperty(parameters, 'auren')),'kilometers': (getObjectProperty(parameters, 'akilometers')),'bedrag': (getObjectProperty(parameters, 'abedrag')),'betreft': (getObjectProperty(parameters, 'abetreft')),'omschrijving': (getObjectProperty(parameters, 'aomschrijving')),'bedragtitel': (getObjectProperty(parameters, 'bedragtitel')),'bedragomschrijving': (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
  ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
  ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
  ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
  ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
  ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
  ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
  ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['werkminuten'] = null;
  ___arguments.context.pageData['kilometers'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratiesindienen/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('Datum activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c61e972ea44d60bf24f273727da2add6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'soort')) == null) {
    (function (message) { alert(message) })('Soort dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'betreft')) == null) {
    (function (message) { alert(message) })('Betreft dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ [`aanmaakdatum`]: (new Date()),[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`soort`]: (getObjectProperty(___arguments.context.pageData, 'soort')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminuten')),[`kilometers`]: (getObjectProperty(___arguments.context.pageData, 'kilometers')),[`bedragcalc`]: (getObjectProperty(___arguments.context.pageData, 'bedraginput')),[`betreft`]: (getObjectProperty(___arguments.context.pageData, 'betreft')),[`omschrijving`]: (getObjectProperty(___arguments.context.pageData, 'omschrijving')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`btw`]: 0,[`tariefkm`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefkm')),[`tarief`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefdeclaraties')),[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`file`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`fileref`]: (getObjectProperty(___arguments.context.pageData, 'file')),[`controle`]: 'TE CONTROLEREN',[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`invoer`]: 'declaratie' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['soort'] = null;
    ___arguments.context.pageData['betreft'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['werkminuten'] = null;
    ___arguments.context.pageData['kilometers'] = null;
    ___arguments.context.pageData['ovparkeerbedrag'] = null;
    ___arguments.context.pageData['paramuren'] = null;
    ___arguments.context.pageData['paramkilometers'] = null;
    ___arguments.context.pageData['parambedrag'] = null;
    ___arguments.context.pageData['parambetreft'] = null;
    ___arguments.context.pageData['paramomschrijving'] = null;
    ___arguments.context.pageData['file'] = null;
    ___arguments.context.pageData['disablesave'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/3342df5cf51474ded7e42463ff683bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');

  },
  /* handler:onUploadFail */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
      await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/declaratiesindienen/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? false : true))))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratiesindienen/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratiesindienen/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratiesindienen/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/declaratiesindienen/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('registratiespzcoach').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',[(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getMonth()) + 1,'-',(new Date((new Date((new Date()).getTime() + (0 * 1000)))).getFullYear())].join(''),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/d6ab1a010ef99e6a2728f9ec9fd2249c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join('')), ({ 'change': false }) );
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\' AND invoer=\'declaratie\''].join('')),'sortBy': 'registratienummer DESC' })));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/declaratiesindienen/components/7e1d1f9b5be6b9bbd598d25cfc3894eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramuren')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/7c71c458d1922ed689458c72733c97d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramuren')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/35ef105247f61d7940db483b9e5c93c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramkilometers')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/422ff6fcd0f10f14ff75eb4fe3472b5c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramkilometers')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC') {
    text = 'Reiskosten eigen vervoer worden vergoed á € 0,19 per kilometer. Registreer de kilometers vanaf postcode vertrek tot postcode aankomst.';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL' || (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
    text = 'Reiskosten eigen vervoer worden vergoed á €0,28 per kilometer. Vul hieronder het totaal aantal kilometers in (postcode vertrek tot postcode aankomst en retour). Geef bij de omschrijving de plaatsnamen of postcodes van vertrek en aankomst weer.';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/1e911222da8da8ae912247b336be6da3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramkilometers')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/737afb2ce06aeace44f69e0c7f161d38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bedragtitel'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/3ebc7c4270cd4075baf7c12551d219a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/26c59bb4ac7ebe6a0423b54b2c2e99db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambedrag')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/declaratiesindienen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var parameters;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['werkminuten'] = null;
  ___arguments.context.pageData['kilometers'] = null;
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['betreft'] = null;
  ___arguments.context.pageData['omschrijving'] = null;
  parameters = (await Promise.all((await Backendless.Data.of('soort').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort=\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setPageSize(100))).map(async parameters => {; return ({ 'uren': (getObjectProperty(parameters, 'auren')),'kilometers': (getObjectProperty(parameters, 'akilometers')),'bedrag': (getObjectProperty(parameters, 'abedrag')),'betreft': (getObjectProperty(parameters, 'abetreft')),'omschrijving': (getObjectProperty(parameters, 'aomschrijving')),'bedragtitel': (getObjectProperty(parameters, 'bedragtitel')),'bedragomschrijving': (getObjectProperty(parameters, 'bedragomschrijving')) });})))[0];
  ___arguments.context.pageData['paramuren'] = (getObjectProperty(parameters, 'uren'));
  ___arguments.context.pageData['paramkilometers'] = (getObjectProperty(parameters, 'kilometers'));
  ___arguments.context.pageData['parambedrag'] = (getObjectProperty(parameters, 'bedrag'));
  ___arguments.context.pageData['parambetreft'] = (getObjectProperty(parameters, 'betreft'));
  ___arguments.context.pageData['paramomschrijving'] = (getObjectProperty(parameters, 'omschrijving'));
  ___arguments.context.pageData['bedragtitel'] = (getObjectProperty(parameters, 'bedragtitel'));
  ___arguments.context.pageData['bedragomschrijving'] = (getObjectProperty(parameters, 'bedragomschrijving'));
  ___arguments.context.pageData['bedraginput'] = null;
  ___arguments.context.pageData['werkminuten'] = null;
  ___arguments.context.pageData['kilometers'] = null;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/declaratiesindienen/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/646c72c5b7de6d7edd5b6d39fc94eb67/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('betreft').find(Backendless.DataQueryBuilder.create().setWhereClause((['soort =\'',(getObjectProperty(___arguments.context.pageData, 'soort')),'\''].join(''))).setSortBy('nr').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'betreft')),'label': (getObjectProperty(item, 'betreft')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambetreft')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/c0db2867755bfb151826ec8960d8422c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'parambetreft')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/c3e7843e2aaa037673a359271e2e32c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramomschrijving')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/47c1362b00419b642796f8dbdb277a66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'paramomschrijving')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/declaratiesindienen/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/18953fe3a81a74c78e69969f4071bd05/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/5b3fa13d070569f12ed78309cb7552ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/81f163647e09f40599a67bce439df575/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND maand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/6687a75c724c5d3d5a6b9a1c0be8a2ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/declaratiesindienen/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultatietransformatie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultatietransformatie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieconsultatietransformatie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratieconsultatietransformatie/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Details registratie ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultatietransformatie/components/74faeddf1d6c23380e249ccc36ee8892/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratieconsultatietransformatie/components/06b6709104495bf6d286967efbafadb5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratiemdo/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratiemdo/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratiemdo/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratiemdo/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Details registratie ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratiemdo/components/74faeddf1d6c23380e249ccc36ee8892/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratiemdo/components/06b6709104495bf6d286967efbafadb5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratieondersteuningpatient/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieondersteuningpatient/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratieondersteuningpatient/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratieondersteuningpatient/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Details registratie ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratieondersteuningpatient/components/74faeddf1d6c23380e249ccc36ee8892/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratieondersteuningpatient/components/06b6709104495bf6d286967efbafadb5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratiesupervisie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function () { window.history.back(); })();
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratiesupervisie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/detailsregistratiesupervisie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/detailsregistratiesupervisie/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Details registratie ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/detailsregistratiesupervisie/components/74faeddf1d6c23380e249ccc36ee8892/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/detailsregistratiesupervisie/components/06b6709104495bf6d286967efbafadb5/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['registratienummer=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'registratienummer')))),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('gebruikersbeheer').find(Backendless.DataQueryBuilder.create().setWhereClause('rol =\'pzcoach\' AND organisatie<>\'Lorio\'').setProperties(['naam', 'username', 'organisatie']).setSortBy('naam ASC').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: [(getObjectProperty(item, 'naam')),' - ',(getObjectProperty(item, 'organisatie'))].join('') });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var email, item, naam;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  naam = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'delenaan')),'\''].join(''))).setProperties(['naam', 'rol', 'organisatie', 'objectId']).setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'naam')),[`rol`]: (getObjectProperty(item, 'rol')),[`organisatie`]: (getObjectProperty(item, 'organisatie')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})))[0];
  ___arguments.context.pageData['delenaannaam'] = ([(getObjectProperty(naam, 'value')),' - ',(getObjectProperty(naam, 'organisatie'))].join(''));
  ___arguments.context.pageData['rol'] = (getObjectProperty(naam, 'rol'));
  ___arguments.context.pageData['userObjectId'] = (getObjectProperty(naam, 'objectId'));
  email = (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'delenaan')),'\''].join(''))).setProperties('email').setPageSize(10))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'email')) });})))[0];
  ___arguments.context.pageData['email'] = (getObjectProperty(email, 'value'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0db2867755bfb151826ec8960d8422c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6118b1fb928591e4c26cadab75e20baf', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/dossierdelen/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var delenaantal;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delenaantal = (getObjectProperty(___arguments.context.pageData, 'delenaantal')) + 1;
  await Backendless.Data.of('Dossiers').bulkUpdate( (['objectId=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossierobjectid')))),'\''].join('')), ({ [`username`]: [(getObjectProperty(___arguments.context.appData, 'dossierusername')),';',(getObjectProperty(___arguments.context.pageData, 'delenaan'))].join(''),[`delenaantal`]: delenaantal }) );
  await Backendless.Data.of('dossierdelen').save( ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'delenaannaam')) }) );
  await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(___arguments.context.pageData, 'userObjectId')), ({ [`___class`]: 'dossiers',[`objectId`]: (getObjectProperty(___arguments.context.appData, 'dossierobjectId')) }));
  await Backendless.Messaging.sendEmailFromTemplate('dossierdelen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`naamverzender`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailtext`]: (getObjectProperty(___arguments.context.pageData, 'emailtext')),[`activiteit`]: (getObjectProperty(___arguments.context.appData, 'activiteit')) }), undefined);
  (function (message) { alert(message) })('Het dossier is gedeeld en uw collega ontvangt hierover een mail.');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/dossierdelen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginapzcoach', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossierdelen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d9b7f9333ab87b651b43caf173aa9e18', (await Backendless.Data.of('dossierdelen').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('naam').setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bd2f238cc6d8870a1d91b64ef1790108', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('delenaantal').setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dossierdelen/components/71e5f46662025d569c545d5ce60a09b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['delenaantal'] = (getObjectProperty(___arguments.context.dataModel, 'delenaantal'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/dossiertoevoegen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/dossiertoevoegen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossiertoevoegen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossiertoevoegen/components/6d37159f217f3efee9d36e45bfdc8be9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierondersteuningpatient', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossiertoevoegen/components/5b838fb4758e9c6a5aafb7c7f6fa2ad5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiermdo', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossiertoevoegen/components/8c22f6b9818c094543978283893137fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossiersupervisie', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/dossiertoevoegen/components/0cb78b84df630a5da73d3ec118dd5521/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('createdossierconsultatietransformatie', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/exports/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvdatapzcoachcontrolefile, csvdatamaandcontrolepzcoach;

/**
 * Describe this function...
 */
async function old() {
  csvdatamaandcontrolepzcoach = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvdataregistratiespzcoach.csv','tableName': 'registratiespzcoach','tableOptions': ({ [`where`]: 'soort <> null',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 10000,[`properties`]: ['soort', 'omschrijving', 'btwplichtig', 'btwinclondersteuningpatient', 'aanmaakmaand', 'naam', 'organisatie', 'registratienummer', 'dossier', 'kilometers', 'werkminuten', 'bedragcalc', 'rol', 'Date(datum) as datum', 'Date(aanmaakdatumcheck) as aanmaakdatumcheck', 'werkminuten', 'tarief', 'werkminutenexbtw', 'werkminutenbtw', 'werkminutentotaal', 'kilometers', 'tariefkm', 'kmexbtw', 'kmbtw', 'kmtotaal', 'bedragcalctotaal', 'totaalexbtw', 'totaalbtw', 'totaalbedrag', 'invoer', 'username'],[`columnsMapping`]: undefined,[`sortBy`]: 'dashboardnaam ASC' }),'csvOptions': ({ [`header`]: true,[`columns`]: ['soort', 'omschrijving', 'btwplichtig', 'btwinclondersteuningpatient', 'aanmaakmaand', 'naam', 'organisatie', 'registratienummer', 'dossier', 'kilometers', 'werkminuten', 'bedragcalc', 'rol', 'datum', 'aanmaakdatumcheck', 'werkminuten', 'tarief', 'werkminutenexbtw', 'werkminutenbtw', 'werkminutentotaal', 'kilometers', 'tariefkm', 'kmexbtw', 'kmbtw', 'kmtotaal', 'bedragcalctotaal', 'totaalexbtw', 'totaalbtw', 'totaalbedrag', 'invoer', 'username'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvdatamaandcontrolepzcoach, false, undefined);
}


  csvdatapzcoachcontrolefile = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvdatapzcoachcontrolefile.csv','tableName': 'registratiespzcoach','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['dashboardnaam', 'aanmaakmaand', 'dossier', 'registratienummer', 'soort', 'kilometers', 'werkminuten', 'bedragcalc', 'rol', 'Date(datum) as datumactiviteit', 'Date(aanmaakdatumcheck) as aanmaakdatumcheck', 'werkminuten', 'tarief', 'werkminutenexbtw', 'werkminutenbtw', 'werkminutentotaal', 'kilometers', 'tariefkm', 'kmexbtw', 'kmbtw', 'kmtotaal', 'bedragcalctotaal', 'totaalexbtw', 'totaalbtw', 'totaalbedrag', 'invoer', 'btwplichtig'],[`columnsMapping`]: undefined,[`sortBy`]: 'dashboardnaam ASC' }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'aanmaakmaand', 'dossier', 'registratienummer', 'soort', 'kilometers', 'werkminuten', 'bedragcalc', 'rol', 'datumactiviteit', 'aanmaakdatumcheck', 'werkminuten', 'tarief', 'werkminutenexbtw', 'werkminutenbtw', 'werkminutentotaal', 'kilometers', 'tariefkm', 'kmexbtw', 'kmbtw', 'kmtotaal', 'bedragcalctotaal', 'totaalexbtw', 'totaalbtw', 'totaalbedrag', 'invoer', 'btwplichtig'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvdatapzcoachcontrolefile, true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/c635f6ceb5773416bf061153edd79ed1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvdatabtwinstellingen;


  csvdatabtwinstellingen = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvdatabtwinstellingenpzcoach.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'dashboardnaam<>\'lori\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['dashboardnaam', 'btwplichtig', 'btwinclondersteuningpatient'],[`columnsMapping`]: undefined,[`sortBy`]: 'dashboardnaam ASC' }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'btwplichtig', 'btwinclondersteuningpatient'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvdatabtwinstellingen, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/95a67196ef21fcad5d911295e34bc099/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvuserdataxlspzoach;


  csvuserdataxlspzoach = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/csvuserdataxlspzoach.csv','tableName': 'Users','tableOptions': ({ [`where`]: 'dashboardnaam<>\'lori\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: 1000,[`properties`]: ['dashboardnaam', 'naam', 'organisatie'],[`columnsMapping`]: undefined,[`sortBy`]: 'dashboardnaam ASC' }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dashboardnaam', 'naam', 'organisatie'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvuserdataxlspzoach, false, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/c8bf17c746b32058cd9e17551da6c311/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvpzcoachdashboard;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvpzcoachdashboard = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/datadashboardregistraties.csv','tableName': 'registratiespzcoach','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['soort', 'activiteit', 'verwijzer', 'dossier', 'omschrijvingactiviteit', 'gemeentewoonplaats', 'afzorgconsumptie', 'bedraginput', 'bedragcalc', 'bedragcalctotaal', 'btwinclondersteuningpatient', 'dashboardnaam', 'mdordoel', 'opcomplexiteitstart', 'opcomplexiteitgeschatresultaat', 'oprcomplexiteitstart', 'oprcomplexiteittoegenomenanders', 'oprdoelcontact', 'oprredenencomplexiteittoegenomen', 'oprredenencomplexiteitverminderd', 'oprsoortcontact', 'Date(opstarttraject) as opstarttraject', 'optzp', 'reistijd', 'tarief', 'tariefkm', 'aanmaakdatumform', 'aanmaakjaar', 'aanmaakmaand', 'aanmaakmaandnum', 'bedragcalcbtw', 'betreft', 'change', 'controle', 'Date(datum) as datum', 'datumdeclaratie', 'invoer', 'kilometers', 'kmtotaal', 'kmbtw', 'kmexbtw', 'maand', 'omschrijving', 'registratienummer', 'rol', 'Date(aanmaakdatumcheck) as created', 'btw', 'totaalexbtw', 'totaalbtw', 'totaalbedrag', 'werkminuten', 'werkminutenbtw', 'werkminutenexbtw', 'werkminutentotaal', 'oprcomplexiteitafgenomenanders'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['soort', 'activiteit', 'verwijzer', 'dossier', 'omschrijvingactiviteit', 'gemeentewoonplaats', 'afzorgconsumptie', 'bedraginput', 'bedragcalc', 'bedragcalctotaal', 'btwinclondersteuningpatient', 'dashboardnaam', 'mdordoel', 'opcomplexiteitstart', 'opcomplexiteitgeschatresultaat', 'oprcomplexiteitstart', 'oprcomplexiteittoegenomenanders', 'oprdoelcontact', 'oprredenencomplexiteittoegenomen', 'oprredenencomplexiteitverminderd', 'oprsoortcontact', 'opstarttraject', 'optzp', 'reistijd', 'tarief', 'tariefkm', 'aanmaakdatumform', 'aanmaakjaar', 'aanmaakmaand', 'aanmaakmaandnum', 'bedragcalcbtw', 'betreft', 'change', 'controle', 'datum', 'datumdeclaratie', 'invoer', 'kilometers', 'kmtotaal', 'kmbtw', 'kmexbtw', 'maand', 'omschrijving', 'registratienummer', 'rol', 'created', 'btw', 'totaalexbtw', 'totaalbtw', 'totaalbedrag', 'werkminuten', 'werkminutenbtw', 'werkminutenexbtw', 'werkminutentotaal', 'oprcomplexiteitafgenomenanders'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvpzcoachdashboard, false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export/dashboardpzcoach.csv'].join('')));
  await Backendless.Data.of('historielogintern').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/dashboardpzcoach.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/1853302707b364f1561a6f2686ea03af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvpzcoachdashboard;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvpzcoachdashboard = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/datadashboardafgesloten.csv','tableName': 'dossiersafgesloten','tableOptions': ({ [`where`]: 'status=\'Afgesloten\'',[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: (await Backendless.Data.of('dossiersafgesloten').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause('status=\'Afgesloten\''))),[`properties`]: ['betreft', 'activiteit', 'consultatieaangevraagd', 'consultatieaangevraagdtoelichting', 'Date(datumafsluiten) as datumafsluiten', 'dossier', 'ervareneigenregie', 'ervareneigenregietoelichting', 'Date(overlijdendatum) as overlijdendatum', 'overlijdenplaats', 'overlijdenplaatsvoorkeur', 'overlijdenopplaatsvoorkeur', 'redenafrondingtraject', 'status', 'tijdigheidsignalering', 'tijdigheidsignaleringtoelichting', 'toegevoegdewaardegoed', 'toegevoegdewaardewatbeter', 'zorgconsumptieplaatsgevonden', 'dashboardnaam'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['betreft', 'activiteit', 'consultatieaangevraagd', 'consultatieaangevraagdtoelichting', 'datumafsluiten', 'dossier', 'ervareneigenregie', 'ervareneigenregietoelichting', 'overlijdendatum', 'overlijdenplaats', 'overlijdenplaatsvoorkeur', 'overlijdenopplaatsvoorkeur', 'redenafrondingtraject', 'status', 'tijdigheidsignalering', 'tijdigheidsignaleringtoelichting', 'toegevoegdewaardegoed', 'toegevoegdewaardewatbeter', 'zorgconsumptieplaatsgevonden', 'dashboardnaam'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvpzcoachdashboard, false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export/dashboardpzcoachafgesloten.csv'].join('')));
  await Backendless.Data.of('historielogintern').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/dashboardpzcoachafgesloten.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/a47946210878cbe6fcb468511af59269/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvpzcoachdashboard;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvpzcoachdashboard = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/datadashboardzorgconsumpties.csv','tableName': 'zorgconsumpties','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: (await Backendless.Data.of('zorgconsumpties').getObjectCount()),[`properties`]: ['soortzorgconsumptie', 'chemotherapie', 'Date(datum) as datum', 'doorwiecomplexiteitingeschat', 'dossier', 'gepland', 'opnameic', 'opnamelanger14dagen', 'anderezorgconsumptie', 'toelichting', 'vermijdbaar'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['soortzorgconsumptie', 'chemotherapie', 'datum', 'doorwiecomplexiteitingeschat', 'dossier', 'gepland', 'opnameic', 'opnamelanger14dagen', 'anderezorgconsumptie', 'toelichting', 'vermijdbaar'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvpzcoachdashboard, false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export/dashboardpzcoachzorgconsumpties.csv'].join('')));
  await Backendless.Data.of('historielogintern').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/dashboardpzcoachzorgconsumpties.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/3b8716a7686e4ada4007541f2c780b04/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvJaaroverzicht;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvJaaroverzicht = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/jaaroverzichtPZcoach.csv','tableName': 'registratiespzcoach','tableOptions': ({ [`where`]: 'controle=\'akkoord\'',[`relations`]: undefined,[`groupBy`]: 'registratienummer',[`pageSize`]: undefined,[`properties`]: ['aanmaakmaand', 'dossier', 'registratienummer', 'soort', 'date(datum) as datum', 'organisatie', 'naam', 'werkminuten', 'kilometers', 'bedragcalc', 'totaalbedrag'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['aanmaakmaand', 'dossier', 'registratienummer', 'soort', 'datum', 'organisatie', 'naam', 'werkminuten', 'kilometers', 'bedragcalc', 'totaalbedrag'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvJaaroverzicht, true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export jaaroverzichtPZcoach.csv'].join('')));
  await Backendless.Data.of('historielogintern').save( ({ [`pagina`]: 'exports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export jaaroverzichtPZcoach.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/6d5e97d391956a81e77bc6b566cd3c43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, dossierdatalist, item, dossierdata;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function ondersteuning_patient() {
  dossierdata = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers' }));
  dossierdatalist = (await Promise.all(dossierdata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`gemeentewoonplaats`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`verwijzer`]: (getObjectProperty(item, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: (getObjectProperty(item, 'opcomplexiteitgeschatresultaat')),[`opcomplexiteitingeschatanders`]: (getObjectProperty(item, 'opcomplexiteitingeschatanders')) });})));
  for (var j_index2 in dossierdatalist) {
    j = dossierdatalist[j_index2];
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ [`gemeentewoonplaats`]: (getObjectProperty(j, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(j, 'activiteit')),[`verwijzer`]: (getObjectProperty(j, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: (getObjectProperty(j, 'opcomplexiteitgeschatresultaat')),[`opcomplexiteitingeschatanders`]: (getObjectProperty(j, 'opcomplexiteitingeschatanders')) }) );
  }
  (function (message) { alert(message) })('Alle registraties zijn geupdate met dossierdata');
}


  dossierdata = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'dossiers' }));
  dossierdatalist = (await Promise.all(dossierdata.map(async item => {; return ({ [`dossier`]: (getObjectProperty(item, 'dossier')),[`gemeentewoonplaats`]: (getObjectProperty(item, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(item, 'activiteit')),[`verwijzer`]: (getObjectProperty(item, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: (getObjectProperty(item, 'opcomplexiteitgeschatresultaat')),[`opcomplexiteitingeschatanders`]: (getObjectProperty(item, 'opcomplexiteitingeschatanders')) });})));
  for (var j_index in dossierdatalist) {
    j = dossierdatalist[j_index];
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['dossier=\'',(getObjectProperty(j, 'dossier')),'\''].join('')), ({ [`gemeentewoonplaats`]: (getObjectProperty(j, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(j, 'activiteit')),[`verwijzer`]: (getObjectProperty(j, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: (getObjectProperty(j, 'opcomplexiteitgeschatresultaat')),[`opcomplexiteitingeschatanders`]: (getObjectProperty(j, 'opcomplexiteitingeschatanders')) }) );
  }
  (function (message) { alert(message) })('Alle registraties zijn geupdate met dossierdata');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/exports/components/46b2bcb8ceb7b852285a33c59b74bc58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvpzcoachdashboard;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  csvpzcoachdashboard = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/datadashboardzorgconsumptiesdata.csv','tableName': 'zorgconsumptiesdata','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: (await Backendless.Data.of('zorgconsumptiesdata').getObjectCount()),[`properties`]: ['dossier', 'zorgconsumptiesplaatsgevonden'],[`columnsMapping`]: undefined }),'csvOptions': ({ [`header`]: true,[`columns`]: ['dossier', 'zorgconsumptiesplaatsgevonden'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvpzcoachdashboard, false, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export/dashboardpzcoachzorgconsumptiesdata.csv'].join('')));
  await Backendless.Data.of('historielogintern').save( ({ [`pagina`]: 'plexports',[`datum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'export/dashboardpzcoachzorgconsumptiesdata.csv',[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/5f4671d2f6343e8584e8771e9352d2b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('4bfb81ae6eba1e373cc65e6db10b6a5b') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/ac87c8fa16e485d293199495c6720a16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('714a0c8633e1f918d035dd02501dd972') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/fb13e3e3e27b9c617ae879cd7fd824c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('7806a82e1e0b7219023eb695d3d6bffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/25c914c5171ae269b454e393f72304e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('945b92fb547905ea356fb78653711ebf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/1d273ce6120df6f357413d362015c2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('0005620b263de57fecf864bd787d1c0c') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturatieadresgegevens/components/7ed532a8f53286c87ccbc39c0bc1050c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('facturatieadresgegevens').save( ___arguments.context.getComponentDataStoreByUid('73d414b6875d33b853a27959c90e2bf9') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/919d2a2a37a2f2e7cd62a03b21cea1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/28b8447172e29462c212d85b3352fb75/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaandgv'] = (getObjectProperty(___arguments.context.pageData, 'filtermaandgv'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\'','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['aanmaakmaand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/987e170c0b1d937d32cfcf8f68ea2744/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause('invoer<>\'projectkosten\'').setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  ___arguments.context.pageData['dossiergemaaktdoor'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/1e6b302b4d24f63d4496ea33fef69a83/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' AND invoer<>\'projectkosten\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == false) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' AND invoer<>\'projectkosten\''].join('')), ({ 'maandakkoord': 0 }) );
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/0148c53e957c3fe5fa5cb1bcd60d491a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == true) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\''].join('')), ({ 'maandakkoord': 1 }) );
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoord')) == false) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\''].join('')), ({ 'maandakkoord': 0 }) );
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/6be48c5fde77b7b91989ec02288b0281/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var j, newuserfactuurnummers, userlistfactuurnummers, userslist, item, users, usersfactuurnummers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function userstoevoegenfactuurnummers() {
  usersfactuurnummers = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurnummers','groupBy': 'username','properties': ['username'] }));
  userlistfactuurnummers = (await Promise.all(usersfactuurnummers.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'users','groupBy': 'username','properties': ['username'] }));
  userslist = (await Promise.all(users.map(async item => {; return (JSON.stringify((getObjectProperty(item, 'username'))));})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    if (!(userlistfactuurnummers.indexOf(j) !== -1)) {
      newuserfactuurnummers = (await Backendless.Data.of('factuurnummers').bulkCreate( (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(JSON.parse(j)),'\''].join(''))).setProperties(['username']).excludeProperties('objectId').setPageSize(10))) ));
    }
  }
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  await userstoevoegenfactuurnummers();
  ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'maandselectie'));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0686cc6cc5b2f1a1cc57e76ab97af1fb', (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'registratiespzcoach','whereClause': 'invoer<>\'projectkosten\'','groupBy': 'aanmaakmaand,username','properties': ['aanmaakmaand', 'username'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/facturenafdrukken/components/0897b51e9f1baf319b2a1a9b3c3781a3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['emailgvakkoord'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0897b51e9f1baf319b2a1a9b3c3781a3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('919d2a2a37a2f2e7cd62a03b21cea1de', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2463fce7d877732c352cca61d0799b5b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('44fbe206bbc2e18884976aacc0bb9d28', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8fac4c7caffcb2e85d37afb8546a7b95', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['centra=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'\' AND maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' ',' AND dossieraanmaker LIKE \'',(getObjectProperty(___arguments.context.pageData, 'dossiergemaaktdoor')),'\''].join(''))).setProperties(['centra', 'maand', 'naam', 'maandakkoord', 'emailgv', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoordgv', 'maandfactuurontvangen', 'username', 'akkoordmaandoverzichtmail']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/dd025f6f9102d4a1d8143fbc30a69704/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaamgv'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registraties').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\'','\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaamgv')),'\' '].join(''))).setProperties(['aanmaakmaand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/e90cc4f5cdf59c88e753cde18cf83bf7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/898553c64828c5fcb2820e2eab2dc235/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('087327bca0a652b5b8b1fa96089d1552')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', true);
    ___arguments.context.pageData['emailaddress'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'email'));
    ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
    ___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56')['email'] = null;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/b41edfafdbcb7e03093e02ad17b3da8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/d5399b2d665c5cab8b8537b49ccb8d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('algemeen', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'emailaddress')), ccAddresses: 'info@lorio.nl', bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'subject': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'subject')),'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'email')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 1500 || 0));
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['email'] = null;
  ___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552')['subject'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('087327bca0a652b5b8b1fa96089d1552', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/a9b6f104ce8475a275ea26da7cce57ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['subject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/facturenafdrukken/components/95b1d104f88c543a7d42a396522dc56e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Stuur hier een mail direct naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('087327bca0a652b5b8b1fa96089d1552'), 'naam')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/745d9ddae15f4e6a67c27b63e6f6bb77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoord')) == 1) {
    if ((getObjectProperty(___arguments.context.appData, 'factdatum')) == null) {
      (function (message) { alert(message) })('Vul eerst de factuurdatum in.');
    } else {
      ___arguments.context.appData['factnaam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'naam'));
      ___arguments.context.appData['factusername'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username'));
      ___arguments.context.appData['factorganisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'organisatie'));
      ___arguments.context.appData['factemailgv'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'email'));
      ___arguments.context.appData['maandselectie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand'));
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand')),'\''].join('')), ({ 'maandakkoordmail': 1 }) );
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('factuurselfbilling', undefined);
    }
  } else {
    (function (message) { alert(message) })('Het maandoverzicht is nog niet akkoord bevonden');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'maandakkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('745d9ddae15f4e6a67c27b63e6f6bb77'))['color'] = '#8cc63f';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/facturenafdrukken/components/68b54708ec81ec8c47c440f611182a18/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'username')),'\' ',' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2e8ae489ca038ad8e99f131ae6592e56'), 'aanmaakmaand')),'\''].join('')), ({ 'maandakkoordmail': 0 }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3a0b2b153156c4349d5e4b984ac4ebdc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['maand', 'naam', 'username', 'email', 'organisatie', 'maandakkoord', 'maandakkoordmail', 'Sum(totaalbedrag) as totaalbedrag']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/facturenafdrukken/components/d3d92e7c1728acd1279dd4ca6ca6c4d1/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var my_12, my_11, my_10, my_9, my_8, my_7, my_6, my_5, my_4, my_3, my_2, my_1, my_36, my_35, my_34, my_33, my_32, my_31, my_30, my_29, my_28, my_27, my_26, my_25, my_24, my_23, my_22, my_21, my_20, my_19, my_18, my_17, my_16, my_15, my_14, my_13;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '1-2023') {
    my_1 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '2-2023') {
    my_2 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '3-2023') {
    my_3 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '4-2023') {
    my_4 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '5-2023') {
    my_5 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '6-2023') {
    my_6 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '7-2023') {
    my_7 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '8-2023') {
    my_8 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '9-2023') {
    my_9 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '10-2023') {
    my_10 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '11-2023') {
    my_11 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '12-2023') {
    my_12 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '1-2024') {
    my_13 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '2-2024') {
    my_14 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '3-2024') {
    my_15 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '4-2024') {
    my_16 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '5-2024') {
    my_17 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '6-2024') {
    my_18 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '7-2024') {
    my_19 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '8-2024') {
    my_20 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '9-2024') {
    my_21 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '10-2024') {
    my_22 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '11-2024') {
    my_23 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '12-2024') {
    my_24 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '1-2025') {
    my_25 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '2-2025') {
    my_26 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '3-2025') {
    my_27 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '4-2025') {
    my_28 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '5-2025') {
    my_29 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '6-2025') {
    my_30 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '7-2025') {
    my_31 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '8-2025') {
    my_32 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '9-2025') {
    my_33 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '10-2025') {
    my_34 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '11-2025') {
    my_35 = '1';
  } else if ((getObjectProperty(___arguments.context.dataModel, 'aanmaakmaand')) == '12-2025') {
    my_36 = '1';
  }
  await Backendless.Data.of('factuurnummers').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.dataModel, 'username')),'\''].join('')), ({ [`F01`]: my_1,[`F02`]: my_2,[`F03`]: my_3,[`F04`]: my_4,[`F05`]: my_5,[`F06`]: my_6,[`F07`]: my_7,[`F08`]: my_8,[`F09`]: my_9,[`F10`]: my_10,[`F11`]: my_11,[`F12`]: my_12,[`F202401`]: my_13,[`F202402`]: my_14,[`F202403`]: my_15,[`F202404`]: my_16,[`F202405`]: my_17,[`F202406`]: my_18,[`F202407`]: my_19,[`F202408`]: my_20,[`F202409`]: my_21,[`F202410`]: my_22,[`F202411`]: my_23,[`F202412`]: my_24,[`F202501`]: my_25 }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/facturenafdrukken/components/7d1daa77d6ef510a20ea8e69ff533b8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.appData['factdatum'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4e8f4ab9b515635b26c4f59772b6a47b', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d1ec530660315f9e649b8c9cef813305', (await Backendless.Data.of('factuurnummers').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a3cbc427f488c8af2774fb1ca7eff3b', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tarief', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'Voorgeschoten kleine uitgaven\' ',' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND soort=\'Reiskosten / parkeerkosten\'',' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\' AND bedragcalc <> 0'].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND bedragcalcbtw<>0'].join(''))).setProperties(['Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND bedragcalcbtw=0'].join(''))).setProperties(['Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw']).setPageSize(100))));
  await new Promise(r => setTimeout(r, 2500 || 0));
  await (async function() {
  	var b = (___arguments.context.pageData['copy']);
  	document.title= b; window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/factuurselfbilling/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/factuurselfbilling/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht registraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.appData, 'maandselectie')),' - ',(getObjectProperty(___arguments.context.appData, 'factnaam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'\'',' AND invoer<>\'projectkosten\' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/cee870e278bab351e4e5e747df4804f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminutenexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/cf1c1b3221568c0946c1d907028d066e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/8d57763628b2680464b48b5f08d2c897/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'tarief')) * 60)));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefkm'));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/factuurselfbilling/components/e61c2ef961933bdcbb89393d96a6b1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/factuurselfbilling/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/2a3cbc427f488c8af2774fb1ca7eff3b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.pageData, 'result')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f34d569b704ca3f582d57dc761d77c13'), 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var copy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14b6ae5812a265798d6226178fa862ef'), 'factuurkwitantie')) == 'Factuur') {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.pageData, 'result'))].join('');
  } else {
    copy = ['Factuur ',(getObjectProperty(___arguments.context.appData, 'factnaam')),'_',(getObjectProperty(___arguments.context.appData, 'maandselectie')),'_',(getObjectProperty(___arguments.context.appData, 'factusername'))].join('');
  }
  ___arguments.context.pageData['copy'] = copy;

  return (getObjectProperty(___arguments.context.appData, 'factnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/539f2d64ba0bafcb899fea4823751527/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'extra')) == false ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('42dfdacf0d7c0b256578d2577ee16774'), 'extrainformatie')) == null) {
    ___arguments.context.pageData['extra'] = false;
  } else {
    text = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('42dfdacf0d7c0b256578d2577ee16774'), 'extrainformatie'));
    ___arguments.context.pageData['extra'] = true;
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.appData, 'factusername')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/factuurselfbilling/components/9dd8aed90e8ff75f0073dbb7e36b237b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'factdatum'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/f6052f0486aa32a77e3ffb9b8b5c75dc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR01'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR02'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR03'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR04'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR05'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR06'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR07'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR08'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR09'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR10'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR11'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2023') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR12'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '1-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202401'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '2-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202402'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '3-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202403'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '4-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202404'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '5-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202405'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '6-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202406'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '7-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202407'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '8-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202408'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '9-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202409'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '10-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202410'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '11-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202411'));
  } else if ((getObjectProperty(___arguments.context.appData, 'maandselectie')) == '12-2024') {
    result = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('aee86ab91313933de54a056f948c6ac2'), 'FNR202412'));
  }
  ___arguments.context.pageData['result'] = result;

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/factuurselfbilling/components/9487a7b938c8f86e58d5b7c72665bcd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminuten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/ab0a286fd4583ecb3a4c3acd7d86928e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/58fe19c93472297544be1b0aeb773d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/5a1d2aab192247abfb9292919a52d0f6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'lastLogin', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/gebruikersbeheer/components/dd2ac4efbecb1abe55a608d2323a9f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0dcd100a43f8da29832aea72b61d49cc')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', true);
  }
  ___arguments.context.pageData['btwplichtig'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/bfad8b5160a8b3e6253374a4c7ba2ce6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);
  ___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829')['selected'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/0ab633ae17a6e5765fa8cd8a0fd2bf63/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('userdeactiveren', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')),[`naamuser`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')) }), undefined);
  await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`actie`]: 'Aanvraag tot deactiveren',[`centraname`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),[`naam`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),[`organisatie`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'organisatie')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'username')) }) );
  (function (message) { alert(message) })((['Het verzoek tot het deactiveren van user ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('39dcb6f40f3de563f3cebbdee6fa3829'), 'naam')),' is verzonden. Wij zullen deze gebruiker zo snel mogelijk op inactief zetten. Tot die tijd vindt u deze gebruiker nog in onderstaande lijst.'].join('')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/gebruikersbeheer/components/87b21c497cf55673c52611530531b85e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39dcb6f40f3de563f3cebbdee6fa3829', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'userStatus')) == 'ENABLED' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/4ecb878544048e22f147a48a121282aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossiers, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'rol')) == null) {
    (function (message) { alert(message) })('De rol dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('De naam dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9bc630a942ec0d4d0357ffe1d2c5823d')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'tariefpzcoachperuur')) == null) {
    (function (message) { alert(message) })('Het tarief van de PZ-coach dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'tariefdeclaratiesperuur')) == null) {
    (function (message) { alert(message) })('Het tarief van de projecten per uur dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Het emailadres dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'organisatie')) == null) {
    (function (message) { alert(message) })('De organisatie dient ingevuld te worden');
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtig')) == null) {
    (function (message) { alert(message) })('De btw plicht dient ingevuld te worden');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'pzcoach') {
      dossiers = true;
      declaraties = true;
    } else {
      dossiers = false;
      declaraties = true;
    }
    await Backendless.Data.of('newuserrequests').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')),[`tariefkm`]: undefined,[`tariefpzcoachperuur`]: (getObjectProperty(___arguments.context.pageData, 'tariefpzcoachperuur')),[`tariefdeclaratiesperuur`]: (getObjectProperty(___arguments.context.pageData, 'tariefdeclaratiesperuur')),[`declaraties`]: declaraties,[`dossiers`]: dossiers,[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`btwinclondersteuningpatient`]: (getObjectProperty(___arguments.context.pageData, 'btwinclondersteuningpatient')) }) );
    await Backendless.Messaging.sendEmailFromTemplate('newuseraanmelding', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`naamnewuser`]: (getObjectProperty(___arguments.context.pageData, 'naam')) }), undefined);
    await Backendless.Data.of('historieaanmeldingusers').save( ({ [`aangemelddoor`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`aanmeldingsdatum`]: (new Date(((new Date()).valueOf()))),[`tariefkm`]: (getObjectProperty(___arguments.context.pageData, 'tariefkm')),[`tariefpzcoachperuur`]: (getObjectProperty(___arguments.context.pageData, 'tariefpzcoachperuur')),[`tariefdeclaratiesperuur`]: (getObjectProperty(___arguments.context.pageData, 'tariefdeclaratiesperuur')),[`rol`]: (getObjectProperty(___arguments.context.pageData, 'rol')),[`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`email`]: (getObjectProperty(___arguments.context.pageData, 'email')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')),[`btwplichtig`]: (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),[`btwinclondersteuningpatient`]: (getObjectProperty(___arguments.context.pageData, 'btwinclondersteuningpatient')),[`declaraties`]: declaraties,[`dossiers`]: dossiers }) );
    (function (message) { alert(message) })('De gebruiker is aangemeld. Wij zullen zo snel mogelijk een account voor de gebruiker aanmaken en hem of haar een mail sturen met de benodigde informatie.');
    ___arguments.context.pageData['rol'] = null;
    ___arguments.context.pageData['naam'] = null;
    ___arguments.context.pageData['tariefpzcoachperuur'] = null;
    ___arguments.context.pageData['tariefdeclaratiesperuur'] = null;
    ___arguments.context.pageData['email'] = null;
    ___arguments.context.pageData['organisatie'] = null;
    ___arguments.context.pageData['btwplichtig'] = false;
    ___arguments.context.pageData['btwplichtigselect'] = false;
    ___arguments.context.pageData['btwinclondersteuningpatient'] = false;
    ___arguments.context.pageData['btwinclondersteuningpatientselect'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dcd100a43f8da29832aea72b61d49cc', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/85afad1323a559a247c7d27e5a26e7c2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == true) {
    ___arguments.context.pageData['btwplichtig'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwplichtigselect')) == false) {
    ___arguments.context.pageData['btwplichtig'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['sorteer'] = 'naam';
  ___arguments.context.pageData['sorteerwijze'] = 'ASC';
  ___arguments.context.pageData['filterenabled'] = 'ENABLED';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'lastLogin', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/gebruikersbeheer/components/736c89422ff2f8161ec73926b835933d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/cea9d95123a6fa28106de5a1f4875142/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gv')) == 'PL' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/30e35eb2b337e024f2ba6312b8eaddcc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'lastLogin', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/187bbb778f8fa873a2435f2662487913/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'lastLogin', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/84a3b24178d6b4bcf1f651b7cd1ac09e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('5a1d2aab192247abfb9292919a52d0f6', (await Backendless.Request.post(`${Backendless.appPath}/services/pagingoverzicht/pagingoverzicht`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': (['userStatus LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterenabled')),'\' AND organisatie<>\'Lorio\''].join('')),'sortBy': ([(getObjectProperty(___arguments.context.pageData, 'sorteer')),' ',(getObjectProperty(___arguments.context.pageData, 'sorteerwijze'))].join('')),'properties': ['dashboardnaam', 'lastLogin', 'naam', 'organisatie', 'rol', 'username', 'userStatus'] })));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/gebruikersbeheer/components/4941c1e28afe9fee39219b9b7a573c78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin')) == null) {
    text = null;
  } else {
    text = (new Intl.DateTimeFormat('de', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1211544d6cbadbd9d5a623429141c27b'), 'lastLogin'))));
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/9bc630a942ec0d4d0357ffe1d2c5823d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'pzcoach' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/gebruikersbeheer/components/ef88e78ea2acc38a2d3dd34c81293284/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'btwinclondersteuningpatientselect')) == true) {
    ___arguments.context.pageData['btwinclondersteuningpatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'btwinclondersteuningpatientselect')) == false) {
    ___arguments.context.pageData['btwinclondersteuningpatient'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/helpdesk/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/helpdesk/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesk/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/helpdesk/components/71bb8c0f36a703f62f7844d46b446c8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('helpdesk', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`userrole`]: (await Backendless.UserService.getUserRoles()),[`vraag`]: (getObjectProperty(___arguments.context.pageData, 'email')) }), undefined);
  ___arguments.context.pageData['email'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8de99e4e3bc3b34cbd29a4ceaea6c9d2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d8725edd14a250fb9adea1b19e9e7439', (await Backendless.Data.of('tarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP2, TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  TEMP2 = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP2 == 0) {
    await Backendless.Data.of('factuurnummers').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/cbab3d4a644c97637c273e566ba1d121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dashboardpzcoach', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/d9235d6b15efdbeb69e939e666ea81b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturatieadresgegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/41ba10f977413b35de910adae4cac0dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/537a729f2f7c991dfa3afb24708ab716/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/8de99e4e3bc3b34cbd29a4ceaea6c9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/547409efeb862f740659c96da97cdda8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('declaratiesindienen', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/36a41e04ad552ab1e745a086780c4ff1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandcontrole', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/b467d911cd5cc1ecbcb6c325cbd7d4f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandakkoord', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/e452c8922e5c6124357381d979e7802f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('projectkosten', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/a267642e3cbec2a21f88eda77a0788f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('facturenafdrukken', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/eff7e5a5baa67393f1973e1b73448408/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndeclaraties', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/15e6858337bbfce3b2b2d379b6da9d48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/456eb323c8d286e2ac8abafb265f2ec9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/e0659551016e9d77d7b9dc5a62bed5b8/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['tariefconsultatietransformatie'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefconsultatietransformatie'))));
  ___arguments.context.appData['tariefdeclaraties'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefdeclaraties'))));
  ___arguments.context.appData['tariefdeclaratieskm'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefdeclaratieskm'))));
  ___arguments.context.appData['tariefmdo'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefmdo'))));
  ___arguments.context.appData['tariefondersteuningpatient'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefondersteuningpatient'))));
  ___arguments.context.appData['tariefsupervisie'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefsupervisie'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/7bdb81f3537b0e17a9aeddc968c994df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/16f5dydMMdVcvmciJlR1vklK86FYQgPGQ/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/93161c2c526279a70c86b3e652cf591f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1e7xDkmYGrF-vdISWsv-DE3FRtpLL3a2h/view?usp=share_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/4c430032a8b31a7d5203584ea8a7895d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('gebruikersbeheer', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/7d3fd6096a0fb9a2b233636cdd3a6c4a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).indexOf('lorio') !== -1) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mailsversturen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/a7f7180dc691b94ae5886f4b2ed3535d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio')) ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/09c6ad2cda828ccee4dd305ccc9511c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('exports', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginabeheerder/components/551886488ca8e2cdbdca08080d9d9c28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('permissions', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8de99e4e3bc3b34cbd29a4ceaea6c9d2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0e8dd614d393b701f6e5a33e8b853a61', (await Backendless.Data.of('tarieven').find(Backendless.DataQueryBuilder.create().setWhereClause((['organisatie=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP2, TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }
  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'ownerId': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'ownerId')) }) );
  TEMP2 = (await Backendless.Data.of('factuurnummers').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP2 == 0) {
    await Backendless.Data.of('factuurnummers').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/cbab3d4a644c97637c273e566ba1d121/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('maandoverzicht', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/365d3c9f35a137ca3804ed1c1c2c413a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/d9235d6b15efdbeb69e939e666ea81b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijngegevens', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/574cd2731569b6041bc8a319aa7b4882/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('declaratiesindienen', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/41ba10f977413b35de910adae4cac0dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/537a729f2f7c991dfa3afb24708ab716/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('helpdesk', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/8de99e4e3bc3b34cbd29a4ceaea6c9d2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['user'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));
  ___arguments.context.appData['centraname'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/c5c494a34b512011e1aeffc6e4b89956/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndeclaraties', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'declaraties'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/547409efeb862f740659c96da97cdda8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'dossiers'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/35b3c162ac8a96532c2a465131d4889d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('...', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/6059177bddcc8479d81fd5ec644b006c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['tariefconsultatietransformatie'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefconsultatietransformatie'))));
  ___arguments.context.appData['tariefdeclaraties'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefdeclaraties'))));
  ___arguments.context.appData['tariefdeclaratieskm'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefdeclaratieskm'))));
  ___arguments.context.appData['tariefmdo'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefmdo'))));
  ___arguments.context.appData['tariefondersteuningpatient'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefondersteuningpatient'))));
  ___arguments.context.appData['tariefsupervisie'] = (JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'tariefsupervisie'))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/7bdb81f3537b0e17a9aeddc968c994df/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1JiFr3tvkJxrmYQS7ad_dT-Vf71Ju8H1n/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://docs.google.com/document/d/1HXQhuKSWlRTLN4lRJj7kkVAMXoMtZjr4/edit?usp=sharing&ouid=111693061307510596670&rtpof=true&sd=true', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/hoofdpaginagebruiker/components/93161c2c526279a70c86b3e652cf591f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'werkgroeplid') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1iIljZeS5z-LGYxiWz-MvARICAlILXAcl/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'stuurgroeplid') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1iIljZeS5z-LGYxiWz-MvARICAlILXAcl/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'projectleiding') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1iIljZeS5z-LGYxiWz-MvARICAlILXAcl/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'projectondersteuning') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1iIljZeS5z-LGYxiWz-MvARICAlILXAcl/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'projectgroeplid') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1iIljZeS5z-LGYxiWz-MvARICAlILXAcl/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'dossiers')) == true) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/10df7gzWc3cTuHoXdosov4RhCFOENX-Fy/view?usp=share_link', true, undefined);
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach' && (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'dossiers')) == false) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1OYdvZzYQGKuZYDEA77yaCEb2ZvQYWFFw/view?usp=share_link', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/db5546014b7940ad8771a98d85f83036/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, transactionId, totpQR_Path, enableResult, secret;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function enable2FA() {
  enableResult = (await Backendless.Request.put(`${Backendless.appPath}/services/TOTP/enable2fa`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  totpQR_Path = (getObjectProperty(enableResult, 'totpQR_Path'));
  secret = (getObjectProperty(enableResult, 'secret'));
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  try {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  );
    ___arguments.context.pageData['transactionId'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId'));
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'totpAuthEnabled')) == false) {
      await enable2FA();
      ___arguments.context.pageData['qrURL'] = ([(Backendless.appPath),'/files/',totpQR_Path].join(''));
      transactionId = (getObjectProperty((await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'password')), false  )), 'transactionId'));
      ___arguments.context.pageData['transactionId'] = transactionId;
    }

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 3033) {
    } else if ((getObjectProperty(error, 'code')) == 3003) {
      await setError((new Error('Gebruikersnaam en/of wachtwoord niet correct')));
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      await setError((new Error('Uw account is geblokkeerd vanwege te veel mislukte aanmeldingen. Uw account zal na 24 uur weer toegankelijk zijn. Indien u eerder weer toegang wilt hebben neem dan contact op met info@lorio.nl')));
    } else {
      await setError(error);
    }

  } finally {
    if (!(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'transactionId')).length) {
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a12c454e2886534edcf4393894d22219', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a69240f4cce6798bf5d2c918c74c2f4', true);
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ce3e81b02364eaa3c0c11e2f895e801')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7dfd192d040ea3656b0b8c42084ff3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username')) == null) {
    (function (message) { alert(message) })('Vul je gebruikersnaam in om het wachtwoord te resetten.');
  } else {
    (function (message) { alert(message) })('Als de opgegeven gebruikersnaam bekend is, is er een e-mail verstuurd met een link om het wachtwoord te resetten.');
    await Backendless.Request.post(`${Backendless.appPath}/services/restorepassword/restorepassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'username'))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/9b250b5ac5ef73d362b40c5ef967bc42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isPasswordVisible'] = (!(getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4edd272bd7fb7f6f22eae3525232662'))['type'] = ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) ? 'input' : 'password');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'isPasswordVisible')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#89b087';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9b250b5ac5ef73d362b40c5ef967bc42'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['isPasswordVisible'] = false;
  ___arguments.context.pageData['qrURL'] = null;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('927c9caef221532a3a695d8ca4ded5cb')));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/inlogpagina/components/8abb41ce996c4b251fb9cfd598ae3f9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error2'] = error;
}


  try {
    await Backendless.UserService.logout();
    await (async function(user, stayLoggedIn) {
    	Backendless.Users.setCurrentUser(user, stayLoggedIn)
    })((await Backendless.Request.post(`${Backendless.appPath}/services/TOTP/auth`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': (Backendless.getCurrentUserToken()) }})).send({ 'transactionId': (getObjectProperty(___arguments.context.pageData, 'transactionId')),'code': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'mfawachtwoord')) })), false);

  } catch (error) {
    if ((getObjectProperty(error, 'code')) == 0) {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    } else {
      await setError(error);
    }

  } finally {
    if (await Backendless.UserService.isValidLogin()) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
      } else if ((await Backendless.UserService.getUserRoles()).includes('Lorio')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
      }
    } else {
      await setError((new Error('De code is niet correct, probeer opnieuw')));
    }

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/0ea61c9bfc8fb45df3185d0f605189d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'qrURL'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/00c12203fb5fb62c8d517401c5968862/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/36fa21579806d20ad65f04de01cb1a6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://drive.google.com/file/d/1Ife0_vQ1jVnr6UzOyO_sXoVB7FW39XY5/view?usp=drive_link', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/e01b293e603bb85559ec1eed97ede07e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'qrURL')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/inlogpagina/components/03713261c0628aac83e20c0e784a23f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/Gebruikersvoorwaarden PZ-coach v1.0.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/inlogpagina/components/7a86dab4fffbf7afa0dc2303b1cc0eec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(Backendless.appPath) + String('/files/privacyverklaring/PrivacyverklaringLoriov1.5.pdf')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filternaam'] = '%';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandakkoord/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7b2d1738387eeb83132702d518878e44', (await Backendless.Data.of('maandafsluiten').find(Backendless.DataQueryBuilder.create().setWhereClause((['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause('invoer<>\'projectkosten\'').setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/6c98989bb6763daf4ef53737e753e4d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandafsluiten')) == true) {
    (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'\''].join('')), ({ 'maandakkoord': true }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 1,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'naam')),'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == false) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand')),'\' AND username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'\''].join('')), ({ 'maandakkoord': false }) );
      await Backendless.Data.of('historiemaandakkoord').save( ({ 'status': 0,'naamakkoordgever': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumakkoord': (new Date()),'usernamegv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'username')),'naamgv': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'naam')),'maand': (getObjectProperty(___arguments.context.pageData, 'filtermaand')) }) );
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandakkoord/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoordmail')) == 1) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('91a638e60d620101fcff5b7fd6d8927d'))['color'] = '#8cc63f';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('91a638e60d620101fcff5b7fd6d8927d'))['color'] = '#545C5C';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/536bf88fa7e15e87091f6692c205d116/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandafsluiten')) == true) {
    (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordalles')) == true) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': true }) );
    } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordalles')) == false) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandakkoord': false }) );
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle = \'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandakkoord/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'registratie\' AND ','aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle = \'AKKOORD\''].join(''))).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoord', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailakkoord')),[`username`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')) }), undefined);
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['username=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'username')),'\' ','AND invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ [`maandakkoordmail`]: 1 }) );
  ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailakkoord'] = 'DE EMAIL IS VERZONDEN';
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/514b87df91c87a0759af23ebde228b54/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' afsluiten'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null) {
    (function (message) { alert(message) })('De maand moet eerst geselecteerd worden voordat de maand afgesloten kan worden.');
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten')) == true) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\'  AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle <>\'AKKOORD\''].join('')), ({ 'maandakkoord': true }) );
      await Backendless.Data.of('maandafsluiten').bulkUpdate( (['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandafsluiten': true }) );
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten')) == false) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\'  AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle <>\'AKKOORD\''].join('')), ({ 'maandakkoord': false }) );
      await Backendless.Data.of('maandafsluiten').bulkUpdate( (['maand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join('')), ({ 'maandafsluiten': false }) );
    }
    ___arguments.context.pageData['maandafsluiten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten'));
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')) != 'Lorio')

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/06d3309bd70efca3bf74803845f86c1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het project PZ Coach is akkoord bevonden. ','U vindt het maandoverzicht in het registratiesysteem van lorio.nl/pz onder de knop \'maandoverzicht\'. Uw factuur zal op korte termijn worden opgemaakt waarna de uitbetaling volgt.'].join('');

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'VIEW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/7b2d1738387eeb83132702d518878e44/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'VIEW'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/3773ea78257c5d888aadf756e5a8a079/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandafsluiten', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
  (function (message) { alert(message) })('Er is een mail verstuurd naar info@lorio.nl om de maand af te laten sluiten.');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/e64bc08e451606ad73ae4ec24c3dfce4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandafsluiten'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5096d101a367f71e12fd42e14f9e8f05'), 'maandafsluiten'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/maandakkoord/components/955aac19c509897e45e9120b7d614bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = ((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND maandakkoord =1'].join(''))).setProperties('email').setGroupBy('email').setPageSize(100))).map(item => item['email']));
  ___arguments.context.pageData['bcc'] = (list.join(','));
  ___arguments.context.pageData['massiveemailakkoord'] = '';
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3026174ea529411886b34b534b3b12b7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('486afa3e2b92de41b7e375562528915c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0391fd66f9b663dececa433fc81c3eb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('901e5f14350333afc77579085ad20882', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/8a7f63f13372b2e8d14377158f079f38/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var emailtext;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  emailtext = ['\'Het maandoverzicht van maand ',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),' van het project PZ Coach is akkoord bevonden. ','U vindt het maandoverzicht in het registratiesysteem van lorio.nl/pz onder de knop \'maandoverzicht\'. Uw factuur zal op korte termijn worden opgemaakt waarna de uitbetaling volgt.'].join('');

  return emailtext

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandakkoord/components/113ee9b7141113d5a24b3b0b64719519/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Messaging.sendEmailFromTemplate('maandoverzichtakkoordmassive', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: [(getObjectProperty(___arguments.context.pageData, 'bcc')), 'backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`maand`]: (getObjectProperty(___arguments.context.pageData, 'filtermaand')),[`naambeheerder`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`emailakkoord`]: (getObjectProperty(___arguments.context.pageData, 'massiveemailakkoord')) }), undefined);
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND maandakkoord =1'].join('')), ({ [`maandakkoordmail`]: 1 }) );
  ___arguments.context.pageData['massiveemailakkoord'] = ('De email is verzonden'.toUpperCase());
  await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0391fd66f9b663dececa433fc81c3eb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('901e5f14350333afc77579085ad20882', false);
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3026174ea529411886b34b534b3b12b7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('486afa3e2b92de41b7e375562528915c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
  ___arguments.context.pageData['massiveemailakkoord'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/c0391fd66f9b663dececa433fc81c3eb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('486afa3e2b92de41b7e375562528915c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3026174ea529411886b34b534b3b12b7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0391fd66f9b663dececa433fc81c3eb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('901e5f14350333afc77579085ad20882', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle=\'AKKOORD\''].join(''))).setProperties(['aanmaakmaand', 'naam', 'organisatie', 'Sum(totaalbedrag) as totaalbedrag', 'maandakkoord', 'maandakkoordmail', 'username', 'email', 'rol']).setSortBy('naam').setGroupBy('username').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/5b59284af23de38bb94737b757a4a837/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvFilepzcoach, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['registraties.aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties(['ibantennamevan', 'ibannummer', 'Sum(registraties.totaalbedrag)/10000 as totaalbedrag', 'registraties.aanmaakmaand as maand', 'registraties.naam as naam', 'registraties.organisatie as organisatie']).setSortBy('registraties.naam').setGroupBy('registraties.username').setPageSize(100)));
  await Backendless.Data.of('verzamelbetaling').bulkDelete( 'objectId is not null' );
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Backendless.Data.of('verzamelbetaling').bulkCreate( list );
  await new Promise(r => setTimeout(r, 1000 || 0));
  csvFilepzcoach = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': 'export/verzamelbetaling.csv','tableName': 'verzamelbetaling','tableOptions': ({ [`where`]: undefined,[`relations`]: undefined,[`groupBy`]: undefined,[`pageSize`]: undefined,[`properties`]: ['tennamevaniban', 'ibannummer', 'totaalbedrag', 'omschrijving'],[`columnsMapping`]: ({ [`tennamevaniban`]: 'Naam begunstigde',[`ibannummer`]: 'IBAN begunstigde',[`totaalbedrag`]: 'Bedrag',[`omschrijving`]: 'Omschrijving' }) }),'csvOptions': ({ [`header`]: true,[`columns`]: ['Naam begunstigde', 'IBAN begunstigde', 'Bedrag', 'Omschrijving'] }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://cvl23.lorio.nl/api/files/') + String(csvFilepzcoach)), true, undefined);
  Backendless.Logging.getLogger('ISO').info((['Intern Lorio-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'-',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-export verzamelbetaling'].join('')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandakkoord/components/514c404a38a51251f10b780e13786b22/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var registratiesobjectId, list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'username'))];
  for (var j_index in list) {
    j = list[j_index];
    registratiesobjectId = (await Backendless.Request.get(`${Backendless.appPath}/services/Pagingrelations/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))) }).send());
    await Backendless.Data.of('factuurgegevens').addRelation((getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/Pagingrelations/pagingrelations`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('factuurgegevens'),'whereClause': JSON.stringify((['username=\'',j,'\''].join(''))),'groupBy': JSON.stringify('username') }).send())[0]), 'objectId')), 'registraties', (registratiesobjectId.map(item => item['objectId'])));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandakkoord/components/bc212608f9072bca4a1e382c3e6c45e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('beheerder'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filteractiviteit'] = '%';
  ___arguments.context.pageData['filternaam'] = '%';
  ___arguments.context.pageData['sorteer'] = 'aanmaakdatum';
  ___arguments.context.pageData['sorteerwijze'] = ' DESC';
  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['controleredenselect'] = null;
  ___arguments.context.pageData['controleredenomschrijving'] = null;
  if (!(getObjectProperty(___arguments.context.appData, 'aanmaakmaand')).length) {
  } else {
    ___arguments.context.pageData['filtermaand'] = (getObjectProperty(___arguments.context.appData, 'aanmaakmaand'));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.appData, 'aanmaakmaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/maandcontrole/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/16e11e116686e6a54544b4f3f778436b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setProperties('aanmaakmaand').setSortBy('created DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'aanmaakmaand')),[`label`]: (getObjectProperty(item, 'aanmaakmaand')) });}))), ({ [`value`]: '%',[`label`]: 'Alle maanden' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/4c323a683cd67f7d2f69c40f0b0bf697/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/eeba4f11ff83adb518cd9bf27c2bfdd6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('naam').setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'naam')),'label': (getObjectProperty(item, 'naam')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/e2c61d87bc58b6e94c2169198c89c24a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/c844a5a1f7dc507f816a71317d32ffe4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/fd4dd1d1870d13bc8fdc99022b466aa2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controleaantekeningen': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')) }) );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')).length == 0) {
  } else {
    await Backendless.Data.of('historiemaandcontrole').save( ({ 'aantekening': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controleaantekeningen')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'datumaantekening': (new Date()),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')) }) );
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/maandcontrole/components/e5ec874e8ac1ea4302eda01272f18515/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/037135840ca7810d32c4ec0a4e432077/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filteractiviteit'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/db3ca88257ea87823aaeddfbab489acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filternaam'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/ea8e5f46728303469314cb096613459d/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/50dd46436e5f16324f9ae3ee4a7d1cc9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefperminuut'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/2da7cb39be92b6abfddf0885874b3b39/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/7007895980926936a54d76ff730aa0d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutenbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/b0a487118b0b294316a88d199f7392a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal')) == 0) {
    euro = null;
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminutentotaal'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/1342996de18c646808b19b7414077874/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'tariefkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/bd170562f2ababa847212538578864a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/e3ef5e35146312ebcf9840bceeb7a932/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/49175a9f72a9bbab12feb41549060c06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kmtotaal'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/cde841b5de47cd08a98c3ed4749cd169/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'bedragcalc'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/f844ad9efa7ba454189e0434e6554814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/3ce8ec9e449489fbef082b640b73e4b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/3abf12aca07134c36e6672126b666e51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'totaalbedrag'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/91a638e60d620101fcff5b7fd6d8927d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74646ffd854f558fd9a98335ba9c9d05')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/d92a86f1e7649229796ac0de2abd89e3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/268315d13ec1372eb592700dcdbb694a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/78464eddc63154cbc5b7bdf79277f436/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()),'maandakkoord': true }) );
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'NIET AKKOORD';
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'controle': 'NIET AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'maandakkoord')) == true) {
      (function (message) { alert(message) })('Deze maand is afgesloten, indien er iets gewijzigd moet worden neem dan contact op met Lorio.');
    } else {
      ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'TE CONTROLEREN';
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
      await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'controle': 'TE CONTROLEREN','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    ___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1')['controle'] = 'AKKOORD';
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
    await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer')),'info': 'registratie komt van status OPNIEUW INGEDIEND','controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = ' #558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78464eddc63154cbc5b7bdf79277f436'))['backgroundColor'] = '#e0ab0d';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/316a7eae0b1698e6b2a692072584ffee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var reden;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null) {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving'));
  } else {
    reden = (getObjectProperty(___arguments.context.pageData, 'controleredenselect'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'controleredenselect')) == null && (getObjectProperty(___arguments.context.pageData, 'controleredenomschrijving')) == null) {
    (function (message) { alert(message) })('Er moet een reden ingegeven worden om deze te kunnen opslaan.');
  } else {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: reden }) );
    await Backendless.Messaging.sendEmailFromTemplate('Niet akkoord mail', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`declaratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),[`reden`]: reden,[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/44c1800c611e457ccea3c1c3bf8fe1aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c2898f6ab7da52d52d372f89653d6a27')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/a03bd34b22899b0547dee5694fe67071/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['controleredenselect'] = ___arguments.value;
  ___arguments.context.pageData['controleredenomschrijving'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/4be4c55422ba25ac0d2ba6135162794d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['controleredenomschrijving'] = ___arguments.value;
  ___arguments.context.pageData['controleredenselect'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/f554972ad0e449e6bf84cadd84a79ea5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/b57472495ac28b5ea4eeaefad27de37f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c2898f6ab7da52d52d372f89653d6a27'), 'registratienummer')),'\''].join('')), ({ 'controlereden': null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c2898f6ab7da52d52d372f89653d6a27', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/31d630dbde2a12a31ae96b0185964e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatum'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/45b5993d55aace9395ccc1425884debe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing')) == null) {
    date = null;
  } else {
    date = (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('66f178392d6c6346cfff015d5ff2bf7e'), 'aanmaakdatumaanpassing'))));
  }

  return date

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/c4ccbd6a6f04b348a061239321f2c7da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('e555df910e182bc184e77dab884c844f'), 'registratienummer')),'\''].join('')), ({ [`controlereden`]: null }) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/a777b7dd0224a80992b1c5f757e293f2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controle')) == 'AKKOORD' ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'controlereden')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e555df910e182bc184e77dab884c844f')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e555df910e182bc184e77dab884c844f', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/20fed8e8bf2983e8087dafada446d176/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, filter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    filter = '%';
  } else {
    filter = (new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit'))));
  }

  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND datumdeclaratie LIKE\'',filter,'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'controle')),'label': (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/327f9226ac9800551351356d1b17eebd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/311f9ec8ebef140a5b39aa58f29fa2e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/2eaab20ea8fc1386191c82882613e89e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9eac710db65ef261ad2a5ce9f85bf19d', true);
  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/471bd6e51d3d40eda49add5d3055bf43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('Informatie aanvraag', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'email')), ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`datum`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'datumdeclaratie')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emailregistratie')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emailregistratie'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Email verzenden naar ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/85a23ced1bdfa10a09f14445f4792fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')))) == null) {
    (function (message) { alert(message) })('De email kan niet verzonden worden zonder een vraag te stellen.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('vraagcontrolelorio', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`registratienummer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'registratienummer')),[`soort`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'soort')),[`gemaaktdoor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'naam')),[`vraag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05'), 'emaillorio')) }), undefined);
    ___arguments.context.getComponentDataStoreByUid('74646ffd854f558fd9a98335ba9c9d05')['emaillorio'] = 'DE EMAIL IS VERZONDEN';
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('74646ffd854f558fd9a98335ba9c9d05', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/1ed2c12a59f6055acd33c8fa28ccbdf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/9eac710db65ef261ad2a5ce9f85bf19d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'filtermaand')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/4bfefdadaf0a0fc299272df7a2c36c45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdatumactiviteit'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandcontrole/components/c3c1a408618c4698041a038b8bdc8f84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', null);
  if ((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')) == null) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND datumdeclaratie LIKE\'',(new Intl.DateTimeFormat('nl', ({ 'dateStyle': 'short' })).format((getObjectProperty(___arguments.context.pageData, 'filterdatumactiviteit')))),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandcontrole/components/9a242dc13bcd421edcba1837cd959aab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'dossier'))));
  ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'registratienummer'))));
  ___arguments.context.appData['aanmaakmaand'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'aanmaakmaand'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Ondersteuning patiënt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieondersteuningpatient', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'MDO') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiemdo', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Supervisie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiesupervisie', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'soort')) == 'Consultatie transformatie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultatietransformatie', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('150aa8e7396d63fbe6f90fb55a7162f1'), 'invoer')) == 'registratie') {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a242dc13bcd421edcba1837cd959aab'))['backgroundColor'] = '#e3e1e1';
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/maandcontrole/components/6536a2f19843c16f32778def6726da52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'','TE CONTROLEREN','\''].join('')), ({ 'controle': 'AKKOORD','controledoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'controledatum': (new Date()) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('486afa3e2b92de41b7e375562528915c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer<>\'projectkosten\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filteractiviteit')),'\' AND naam LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify((String(getObjectProperty(___arguments.context.pageData, 'sorteer')) + String(getObjectProperty(___arguments.context.pageData, 'sorteerwijze')))) }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  ___arguments.context.pageData['SOURCE'] = ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0ae9330cf0d1e6e61dffad9e359f0f65', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async onLeave(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/maandoverzicht/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/a6ddb20388c34e97afd58d61b4165803/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maandselectie'] = ___arguments.value;
  ___arguments.context.pageData['VIEW'] = true;
  ___arguments.context.pageData['maandoverzichtakkoord'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2a3cbc427f488c8af2774fb1ca7eff3b', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer<>\'projectkosten\'',' AND controle=\'AKKOORD\''].join(''))).setProperties(['soort', 'Sum(werkminuten) as werkminuten', 'tarief', 'Sum(werkminutenbtw) as werkminutenbtw', 'Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutentotaal) as werkminutentotaal']).setSortBy('soort').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('939999edb5583bbab536c081385848eb', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Voorgeschoten kleine uitgaven\' ',' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('bfc81f8d0c18cd3d7b0b509254658aea', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND invoer=\'declaratie\'',' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['soort', 'Sum(kilometers) as kilometers', 'tariefkm', 'Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw', 'Sum(kmtotaal) as kmtotaal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2cdcf3f53982659a3ff5795da2921a7c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND soort=\'Reiskosten / parkeerkosten\'',' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\' AND bedragcalc <> 0'].join(''))).setProperties(['soort', 'Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw', 'Sum(bedragcalctotaal) as bedragtotaal', 'count(soort) as aantal']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('4b671b666ea23d6388abf866da9a5265', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2f92fe698a6874ac236e8d9706697404', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a37f9a2a8242171fe996800f00649137', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\''].join(''))).setProperties(['Sum(totaalexbtw) as totaalexbtw', 'Sum(totaalbtw) as totaalbtw', 'Sum(totaalbedrag) as totaalbedrag']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('54d7ce7eae72101b7dbbb77e4a7c76e3', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND werkminutenbtw<>0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('1b2952a3e33a320d724e9fe104bf1d77', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND werkminutenbtw=0'].join(''))).setProperties(['Sum(werkminutenexbtw) as werkminutenexbtw', 'Sum(werkminutenbtw) as werkminutenbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ad19a9d812d2e882aaccd926cc93bae', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND kmbtw<>0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6af6656ec155713eafae0c219c5f92bf', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND kmbtw=0'].join(''))).setProperties(['Sum(kmexbtw) as kmexbtw', 'Sum(kmbtw) as kmbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735c348a8ae4e1171f826e03398c8db5', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND bedragcalcbtw<>0'].join(''))).setProperties(['Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0de98b3decfc934a30d76c9afdf43009', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\' AND controle=\'AKKOORD\' AND invoer<>\'projectkosten\'',' AND bedragcalcbtw=0'].join(''))).setProperties(['Sum(bedragcalc) as bedragexbtw', 'Sum(bedragcalcbtw) as bedragbtw']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f2b8655d760b784883b545b5e2c60f9c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\''].join(''))).setProperties('maandoverzichtakkoord').setGroupBy('maandoverzichtakkoord').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('aanmaakmaand').setSortBy('aanmaakmaand DESC').setGroupBy('aanmaakmaand').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/b0495ea9577baec3b00e1bdb81c40087/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/4dde07442c35a5971c0998aab823946b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/edb51285268cb33640d5a04a94da665f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/59e66456051b2e07f5a8a6aaea5e262d/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Overzicht registraties ingevoerd in de maand ',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),' - ',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))].join(''))

  },
  /* handler:onTitleAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onColumnsAssignment */
  async ['onColumnsAssignment'](___arguments) {
    var G, item, F, E, D, C, B, A;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return (await asyncListFilter((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('59e66456051b2e07f5a8a6aaea5e262d')), 'columns')), async (item) => {
   if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'projectlid') {
    A = 'Dossiernummer';
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'BL') {
  } else if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'PL') {
  }


 return ((getObjectProperty(item, 'title')) != A && (getObjectProperty(item, 'title')) != B && (getObjectProperty(item, 'title')) != C && (getObjectProperty(item, 'title')) != D && (getObjectProperty(item, 'title')) != E && (getObjectProperty(item, 'title')) != F && (getObjectProperty(item, 'title')) != G);
}))

  },
  /* handler:onColumnsAssignment */
  /* handler:onWhereClauseAssignment */
  async onWhereClauseAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(getObjectProperty(___arguments.context.pageData, 'maandselectie')),'\'',' AND controle=\'AKKOORD\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/cee870e278bab351e4e5e747df4804f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminutenexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/cf1c1b3221568c0946c1d907028d066e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminutenbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminutenbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/e5f121045216195374a7825655bcdf27/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('02446c49596fab9152d71a7c6b54dcc2'), 'totaalexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/8d57763628b2680464b48b5f08d2c897/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'tarief')) * 60)));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/825eed757945b00fcf1397ec25ca037a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'tariefkm'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/442a8d859c447ed5ece2ad715a94104c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/ee6ffde4e713391cdd28da05ff492cc3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('651ef5a1ff7afef951671c02d2134b1c'), 'kmbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/b43128b24b58cfa98f6c86e90449fbfa/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b43128b24b58cfa98f6c86e90449fbfa', (await Backendless.Data.of('facturatieadresgegevens').find(Backendless.DataQueryBuilder.create().setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/0083293170ed7a7905189a83ba718e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  list = [(getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord'))];
  for (var j_index in list) {
    j = list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'maandoverzichtakkoord')) == 1) {
      ___arguments.context.pageData['maandoverzichtakkoord'] = 1;
    }
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/759ff4ee989244a40dd78fe5ff77b787/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/8d182e157fa1e64dca945f6317ca70a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/deee0a06623c9e44e6e9ebe96dc916ce/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('deee0a06623c9e44e6e9ebe96dc916ce', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/0d3e958c47d525ca4ee375b67884f1b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'postcode')),' ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/167e783ed44c844f7d93d60d07e3ace2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandselectie')) == null) {
    (function (message) { alert(message) })('U dient eerst de maand te selecteren voordat u een factuur kunt opmaken.');
  } else {
    ___arguments.context.pageData['FACTGEGEVENS'] = true;
    ___arguments.context.pageData['INVOICE'] = false;
    ___arguments.context.pageData['VIEW'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', true);
    await Backendless.Data.of('factuurgegevens').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'factuurnummer': null }) );
    ___arguments.context.pageData['factuurnummer'] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/359deb7271c7ebc941874474de24a14c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/25386f857648dae49aa8aff65f0ec5af/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'FACTGEGEVENS')) == true) {
    visible = true;
  } else {
    visible = false;
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('25386f857648dae49aa8aff65f0ec5af', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/58cd94c8d92e575ac13d5bc664ffa391/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/e61405f3e5e9e8d92f3a4a53b289d06d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/d05dde1c23aae976ac4d1711c99db218/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/8f465d5f56d41fd77d3bba4ad0fe1cd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/b042965597ab58d182efe49443d2bd4c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/c46c49345d390b33f8f9fe4c18d43641/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/48abbe635c4cf09158ea9065bc590d1f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/06657ca945c2ad438fa409dbc9faed18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/574a0f155f748c53e9a5d71345bdf882/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/001baa1ff71bca787fcdf7f87e51e458/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/8af521110fc5173b5566a99943f30197/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/ca654e33a74a3908db4f71d17b9ba957/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/9695d8b181662d02ba845776ecb88571/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/d31cb031efe92bcef27dd30c166debe9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/7acd8669688de30b25f548a20e3934aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/2da62ab21281ef0706b209e5fa7ef6b5/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('2da62ab21281ef0706b209e5fa7ef6b5', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/9a07a37569c9d2f84437f1ab9add098d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (new Intl.DateTimeFormat('de', undefined).format((new Date())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/86e2eaaf2781f02ae9f8344f58a9ffe3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'maandselectie'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/c415e9bfc50ea9780785b50471299bd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')).length) {
    (function (message) { alert(message) })('U moet aangeven of het een factuur of kwitantie betreft.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8af521110fc5173b5566a99943f30197')), 'display')) == true && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurnummer')) == null) {
    (function (message) { alert(message) })('Het factuurnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'bedrijfsnaam')).length) {
    (function (message) { alert(message) })('De naam of bedrijfsnaam moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'adres')).length) {
    (function (message) { alert(message) })('Het adres moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'postcode')).length) {
    (function (message) { alert(message) })('De postcode moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'woonplaats')).length) {
    (function (message) { alert(message) })('De woonplaats moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'email')).length) {
    (function (message) { alert(message) })('Het emailadres moet ingevuld worden..');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48abbe635c4cf09158ea9065bc590d1f')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'kvknummer')).length) {
    (function (message) { alert(message) })('Het kvknummer moet ingevuld worden.');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06657ca945c2ad438fa409dbc9faed18')), 'display')) == true && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'btwnummer')).length) {
    (function (message) { alert(message) })('Het btwnummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibannummer')).length) {
    (function (message) { alert(message) })('Het ibannummer moet ingevuld worden.');
  } else if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'ibantennamevan')).length) {
    (function (message) { alert(message) })('Ten name van moet ingevuld worden.');
  } else if ((getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == 0 || (getObjectProperty(___arguments.context.pageData, 'maandakkoordstatus')) == null) {
    (function (message) { alert(message) })('De factuur kan enkel opgemaakt worden als het maandoverzicht akkoord is bevonden.');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['height'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['minHeight'] = '700px';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e667bba5f102a9caece20de5f5cc7612'))['maxHeight'] = '700px';
    ___arguments.context.pageData['FACTGEGEVENS'] = false;
    ___arguments.context.pageData['INVOICE'] = true;
    ___arguments.context.pageData['VIEW'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da41d212ae6863d38204da52c1b9e1f8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function() {
    	window.print()
    })();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) + String(' opmaken'))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/29b1b26478246886942dcd297b5ff4f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/4fd709b151d62e041a7c3481ece40e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['FACTGEGEVENS'] = false;
  ___arguments.context.pageData['VIEW'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8a7df613dce090b3c5cc033af4f2263', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f2b8655d760b784883b545b5e2c60f9c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1a515dc716eb79fcdca408ce2b4443bb', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ae9330cf0d1e6e61dffad9e359f0f65', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29b1b26478246886942dcd297b5ff4f3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4fd709b151d62e041a7c3481ece40e03', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/e61c2ef961933bdcbb89393d96a6b1de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f7744df83685a5d83daa63a812741f1', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b1ffbd7fa02034b26d54a0b2235c401', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/38288ef8776bacfe3338d7249f0c36ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/2a3cbc427f488c8af2774fb1ca7eff3b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/bfc81f8d0c18cd3d7b0b509254658aea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/4b671b666ea23d6388abf866da9a5265/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/834cfcd4e27b987ed4466cb27c593dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/9f06ba9552a302e9bfa60d92b9caf9ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'factuurkwitantie')) == 'Factuur') {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),' onder vermelding van factuurnummer ',(getObjectProperty(___arguments.context.dataModel, 'factuurnummer')),'.'].join('');
  } else {
    content2 = ['Wij verzoeken u vriendelijk het bedrag van ',(getObjectProperty(___arguments.context.pageData, 'totaalbedrag')),' binnen 30 dagen over te maken naar rekeningnummer ',(getObjectProperty(___arguments.context.dataModel, 'ibannummer')),' ten name van ',(getObjectProperty(___arguments.context.dataModel, 'ibantennamevan')),' te ',(getObjectProperty(___arguments.context.dataModel, 'woonplaats')),'.'].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/f34d569b704ca3f582d57dc761d77c13/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f34d569b704ca3f582d57dc761d77c13', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/9c8b0b4e51116ce2f46c01ae2a7aee36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/e195e98ec5550d29d8e9b78feccbe4b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('84430d2edca3a70f79d201126ff94375'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/4e8f4ab9b515635b26c4f59772b6a47b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'INVOICE')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/2cdcf3f53982659a3ff5795da2921a7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/287287e80ea50567800225954bc9846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3aad1d9b05d8dbb6a044dc8b5f3495d6'), 'totaalbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/42464328b06c3752cea38d2163767e1f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a35d3424c933ab3c272c926c25ccf46a'), 'totaalbedrag'))));
  ___arguments.context.pageData['totaalbedrag'] = euro;

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/cd9c573c7d9b4fde829786d51d4d3e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['inclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/d91f7ff4b2d96b7c4e18762a1dca46b4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclurenexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenexbtw'));
  ___arguments.context.pageData['exclurenbtw'] = (getObjectProperty(___arguments.context.dataModel, 'werkminutenbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/64561efe908764ae5c6f20d4abe96868/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['inclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/364e6219fc5ff9c198e6aa8c015b7dda/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclkmexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmexbtw'));
  ___arguments.context.pageData['exclkmbtw'] = (getObjectProperty(___arguments.context.dataModel, 'kmbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/058d76a9a81f00638655cf8b0da9d2b6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['inclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['inclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/4ab23618a7a8c3494357e6cf5b9220a6/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['exclbedragexbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragexbtw'));
  ___arguments.context.pageData['exclbedragbtw'] = (getObjectProperty(___arguments.context.dataModel, 'bedragbtw'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/7b8465ac5d722799e22bfac594b51c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/a5390634b17a414c9ded4a72641c81f5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmexbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragexbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/bcfa0f2770a9b082f7d3e74b107c3afe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'exclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'exclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/2841456ab0ca8b1de649b233ac5e51f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })(((getObjectProperty(___arguments.context.pageData, 'inclurenbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclkmbtw')) + (getObjectProperty(___arguments.context.pageData, 'inclbedragbtw')))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/34be58fed185e7f99a080af5778ac4b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/e39b8939739fadff893413ca228af41d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/1668b0453df80c8ce9dfe71be69fb853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/2f92fe698a6874ac236e8d9706697404/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/a37f9a2a8242171fe996800f00649137/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/5e7d19b2f1a52b3477ff91dda6db4de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/539f2d64ba0bafcb899fea4823751527/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'werkminutentotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/651ef5a1ff7afef951671c02d2134b1c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'kmtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/84430d2edca3a70f79d201126ff94375/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == 0 || (getObjectProperty(___arguments.context.dataModel, 'bedragtotaal')) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/9abccdb7d87b42cbc4bb37cfb854ad51/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(Backendless.appPath),'/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/3ddf7cac281621eeec87c315dbb28265/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/735616997b3586fd6d644757da252a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('735616997b3586fd6d644757da252a2d', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/b47731d1e605fb51fdf28405747a1ffb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.dataModel['factuurnummer'] = null;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/maandoverzicht/components/599b909b0142fe61127df516ca5aa6dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/maandoverzicht/components/bad1987b2381573e85b317378631dc9a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('b47731d1e605fb51fdf28405747a1ffb') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/maandoverzicht/components/42dfdacf0d7c0b256578d2577ee16774/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('42dfdacf0d7c0b256578d2577ee16774', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setProperties('extrainformatie').setPageSize(10))) == null ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/9dd4e9d3bc5e91efda29f6ad206e0f65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'extrainformatie')) == null) {
    text = '';
  } else {
    text = (getObjectProperty(___arguments.context.dataModel, 'extrainformatie'));
  }

  return (String('Extra informatie: ') + String(text))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/939999edb5583bbab536c081385848eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'VIEW')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/7affd3f93f5164c533823f06b6eaef2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragbtw')) == null) {
    text = '0%';
  } else {
    text = '21%';
  }

  return text

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/ba387c2234abc37414272dee9a5e4bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0fcc56ff9dd3abcad5381bd605c15cfd'), 'bedragexbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/d6a188e563f6175576de4a5e75b6920c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'maandoverzichtakkoord')) == 1) {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 1;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', false);
  } else {
    ___arguments.context.pageData['maandakkoord'] = 'Dit maandoverzicht is nog niet akkoord bevonden.';
    ___arguments.context.pageData['maandakkoordstatus'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4623293c2cadaad53438843111776272', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79c30a152275b9ad1116e18dbfe3b104', true);
  }

  return (getObjectProperty(___arguments.context.pageData, 'maandakkoord'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/65954fc8c812d86e6e1d71bedb37196c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/maandoverzicht/components/9487a7b938c8f86e58d5b7c72665bcd5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('539f2d64ba0bafcb899fea4823751527'), 'werkminuten'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mailsversturen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mailsversturen/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mailsversturen/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mailsversturen/components/c6c40c1cd7f534d63d953c4b544574fb/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause('userStatus = \'ENABLED\'').setProperties('username').setSortBy('dashboardnaam ASC').setGroupBy('username').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'username')) });})))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3d09c7210d6a7915bf853d1dff6efcb8', (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty(___arguments.context.pageData, 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mailsversturen/components/af28aaaf88cfc242eaeb9b79ef3c4a56/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'rol'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/mailsversturen/components/a7a1a305985db5a516254c8a560648cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'rol')) == 'pzcoach') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserpzcoach', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else if ((getObjectProperty(___arguments.context.dataModel, 'rol')) == 'beheerder') {
    await Backendless.Messaging.sendEmailFromTemplate('newuserbeheerder', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('newuserprojectleden', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.dataModel, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.dataModel, 'naam')),[`username`]: (getObjectProperty(___arguments.context.dataModel, 'username')),[`organisatie`]: (getObjectProperty(___arguments.context.dataModel, 'organisatie')) }), undefined);
    (function (message) { alert(message) })('De email is verzonden');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/24c59afc9b7869a85ebbcb3dbd4e1823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = 0;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == null) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == false) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) != 'AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Ondersteuning patiënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Supervisie' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Consultatie transformatie' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'MDO' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : true))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')) == 0) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/cdc6c82bd72ed8df431d68254ec75002/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) != true ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? false : true)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc')) == 0) {
    euro = '-';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/0a9a0e7fc609f0536cd4851d2431f799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Werktijd' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Ondersteuning patiënt' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Supervisie' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Consultatie transformatie' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'MDO' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiemijndeclaraties').save( ({ 'soort': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'werkminuten': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'werkminuten')),'datum': ((new Date()).valueOf()) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/mijndeclaraties/components/8d349db77ecb28f4320418027913049c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : false) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiemijndeclaraties').save( ({ 'soort': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'kilometers': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'kilometers')),'datum': ((new Date()).valueOf()) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/mijndeclaraties/components/e1584521a9f12d5e7fa6bcceefb3de9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Reiskosten / parkeerkosten' ? true : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Voorgeschoten kleine uitgaven' ? true : false)) : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiemijndeclaraties').save( ({ 'soort': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'bedraginput': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedraginput')),'datum': ((new Date()).valueOf()) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/mijndeclaraties/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/3466f6d2e332d4470ba847ba5d5bcb4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/b17a9c5be42f40f4f4c4a2d438825853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = ([(Backendless.appPath),'/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('b17a9c5be42f40f4f4c4a2d438825853');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/mijndeclaraties/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('registratiespzcoach').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref')) == null) {
  } else {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3466f6d2e332d4470ba847ba5d5bcb4b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['filterstatus'] = '%';
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')), ({ 'change': false }) );
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijndeclaraties/components/f992a0fc4606d7ce4a22b8a29a4866db/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag')) == 0) {
    euro = null;
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'totaalbedrag'))));
  }

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/6658af14ef125f3b1da798ee92c85184/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac') );

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('historiemijndeclaraties').save( ({ 'soort': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')),'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'omschrijving': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'omschrijving')),'datum': ((new Date()).valueOf()) }) );

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/mijndeclaraties/components/fbcb0639f0a88b6106985c5ea3916098/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/b8abb0b929925621d74834d7f84ba81e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    var label;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'TE CONTROLEREN') {
    label = 'te controleren';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = 'grey';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'AKKOORD') {
    label = 'akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#558153';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'NIET AKKOORD') {
    label = 'niet akkoord';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#d24f42';
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'controle')) == 'OPNIEUW INGEDIEND') {
    label = 'opnieuw ingediend';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b8abb0b929925621d74834d7f84ba81e'))['backgroundColor'] = '#e0ab0d';
  }

  return label

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/61fb7db6d2c2cabad2d63507fe829a43/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'maandakkoord')) == true) {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'objectId')),'\''].join('')), ({ 'change': false,'aanmaakdatumaanpassing': (new Date()),'controle': 'OPNIEUW INGEDIEND','maandakkoord': false }) );
    await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'registratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'OPNIEUW INGEDIEND','maandakkoord': false,'activiteitdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (message) { alert(message) })('De declaratie is opnieuw ingediend');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d10e4d172897ca2c4a1202a11bf8e7a5', false);
  } else {
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'objectId')),'\''].join('')), ({ 'change': false,'controle': 'OPNIEUW INGEDIEND' }) );
    await Backendless.Data.of('historiestatus').save( ({ 'registratienummer': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d10e4d172897ca2c4a1202a11bf8e7a5'), 'registratienummer')),'aanmaakdatumaanpassing': (new Date()),'controle': 'OPNIEUW INGEDIEND','maandakkoord': false,'activiteitdoor': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
    (function (message) { alert(message) })('De declaratie is opnieuw ingediend');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d10e4d172897ca2c4a1202a11bf8e7a5', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/d10e4d172897ca2c4a1202a11bf8e7a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'change')) == true && (getObjectProperty(___arguments.context.dataModel, 'controle')) == 'NIET AKKOORD' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/938d30edda12673e1914c67b903b01f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/072cdd11d74fc821eaaec9eeea9e4c0f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['registratienummer LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterdeclaratienummer')),'%\'','AND username =\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijndeclaraties/components/6a3b7b69cd95019f9bd477f7a8f8e834/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND ','aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\''].join(''))).setProperties('controle').setSortBy('controle ASC').setGroupBy('controle').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'controle')),'label': (getObjectProperty(item, 'controle')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/f6e4eabb330a00e398e11533c36211b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterdeclaratienummer'] = null;
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND ','controle LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'%\''].join(''))).setProperties('aanmaakmaand').setSortBy('aanmaakmaand ASC').setGroupBy('aanmaakmaand').setPageSize(10))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaand')),'label': (getObjectProperty(item, 'aanmaakmaand')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/e0cec201524fc0b9ce5edc2378694b59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filterstatus'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/00b628d698e515548e1c9525c73db767/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['filtermaand'] = '%';
  ___arguments.context.pageData['pageoffset'] = 0;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/28c1e187a48a63d75ba160d481b41918/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null) {
  } else {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));
  }
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'change')) == true ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref')) == null ? false : true) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/d229ab1a613e24df18a57658f639f02b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/6687a75c724c5d3d5a6b9a1c0be8a2ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'betreft')) == null) {
    value = '-';
  } else {
    value = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'betreft'));
  }

  return value

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/4b7573b6cbec91dba72267cd5bca7c6d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 == 0) {
    return2 = 1;
  } else {
    return2 = (getObjectProperty(___arguments.context.pageData, 'pageoffset')) / 100 + 1;
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/mijndeclaraties/components/b83ccfd16786e118f5b4582fbd5e6b8c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) == 0) {
  } else {
    ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) - 100);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/cd5d87bd5b35e2a45236ab126f53f583/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['pageoffset'] = ((getObjectProperty(___arguments.context.pageData, 'pageoffset')) + 100);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\' AND aanmaakmaand LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filtermaand')),'\' AND controle LIKE\'',(getObjectProperty(___arguments.context.pageData, 'filterstatus')),'\' AND invoer<>\'projectkosten\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100).setOffset((getObjectProperty(___arguments.context.pageData, 'pageoffset'))))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndeclaraties/components/4217113409be60d7dd6cd6493cb4561e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'dossier'))));
  ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'registratienummer'))));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Ondersteuning patiënt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieondersteuningpatient', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'MDO') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiemdo', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Supervisie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiesupervisie', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'soort')) == 'Consultatie transformatie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultatietransformatie', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.appData['startpaginamijndossiers'] = 'alleactiviteiten';
  ___arguments.context.pageData['visible'] = (getObjectProperty(___arguments.context.appData, 'startpaginamijndossiers'));
  ___arguments.context.pageData['statusfilter'] = 'Actief';
  ___arguments.context.pageData['filternaam'] = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/mijndossiers/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/9887f9a249efcf19f323282ee01e0513/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/e30f956f40595365da44e8c750f3a3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossiertoevoegen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijndossiers/components/9047360d23d26106f82f8f31934d232a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'ondersteuningpatient' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/22f25858fd579a51f9845da763a2e1ba/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'mdo' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/01a1ce99fb96d93c5e949457fe393fc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'supervisie' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/87df61ae8edcdcfa62fb5943d3747a01/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'consultatietransformatie' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/b7b96b1da952e3f63ef5162a298c7967/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'visible')) == 'alleactiviteiten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/a67ea79e5edfb40fc14ab7c2968b462e/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'ondersteuningpatient';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'%\'',' AND activiteit=\'','Ondersteuning patiënt','\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/38ef3736ae1f8f773f664ebd1eb8cad6/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'mdo';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'%\'',' AND activiteit=\'','MDO','\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/d4aeaa0ff971bda840c661ebf7cf31cd/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'supervisie';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'%\'',' AND activiteit=\'','Supervisie','\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/62a5751264b66af4cb87cb98f6357259/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'consultatietransformatie';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'%\'',' AND activiteit=\'','Consultatie transformatie','\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/88077e8d433b8f432aea4386a6bde985/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossier'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossier'))));
  ___arguments.context.appData['dossierobjectid'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'objectId'))));
  ___arguments.context.appData['dossierstatus'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'status'))));
  ___arguments.context.appData['dossieraanmaker'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'dossieraanmaker'))));
  ___arguments.context.appData['activiteit'] = (JSON.stringify((getObjectProperty(___arguments.selectedRecord, 'activiteit'))));
  ___arguments.context.appData['startpagemijndossiers'] = 'alleactiviteiten';
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['username LIKE\'%',(getObjectProperty(___arguments.context.pageData, 'filternaam')),'%\' AND status LIKE\'',(getObjectProperty(___arguments.context.pageData, 'statusfilter')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/mijndossiers/components/db77137c2a749d12edf64198bd418313/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause('created is not null').setProperties(['naam', 'username']).setSortBy('naam ASC').setGroupBy('naam').setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'username')),[`label`]: (getObjectProperty(item, 'naam')) });}))), ({ [`value`]: '%',[`label`]: 'Alle dossiers' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if ((await Backendless.UserService.getUserRoles()).includes('beheerder')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/cbe40e7fe223de879fdcc794e22ef1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cbe40e7fe223de879fdcc794e22ef1b2', (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/24448b06c05c53a4a4c7f366d736403e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail. ');
  } else if ((getObjectProperty(___arguments.context.pageData, 'emailupdate')) == 'DE EMAIL IS VERZONDEN') {
    (function (message) { alert(message) })('De email is reeds verzonden');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('useraanpassingen', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`gebruiker`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`emailupdate`]: (getObjectProperty(___arguments.context.pageData, 'emailupdate')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) }), undefined);
    ___arguments.context.pageData['emailupdate'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    ___arguments.context.pageData['emailupdate'] = '';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/mijngegevens/components/b7cd3465433ff6d941452d0458e2f0c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwplichtig')) == 1 ? 'Ja' : 'Nee')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['SOURCE'] = (['https://pzcoach.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg'].join(''));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('509b2e9dd3b1166801d5a401f6da6fa8', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var TEMP;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  TEMP = (await Backendless.Data.of('factuurgegevens').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join('')))));
  if (TEMP == 0) {
    await Backendless.Data.of('factuurgegevens').save( ({ 'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('509b2e9dd3b1166801d5a401f6da6fa8', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/mijngegevens/components/b92e094af901585b56f3f9fd132ba2d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/7b8304e6917e23cb12d74c36de2937ea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'NC' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/57eb1fc20f61cc7f8d5fc9fe37b56a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/ad76d327dd3d182c19f36f96773b0ab3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ad76d327dd3d182c19f36f96773b0ab3', (await Backendless.Data.of('factuurgegevens').find(Backendless.DataQueryBuilder.create().setWhereClause((['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\''].join(''))).setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/mijngegevens/components/5b2a824695749c17cb4da796cdfcecf5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/f5596b12de2bd03f1ed94a43ef1138dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/2adafcd487e2cf4a306d6bb893179bfe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/b9e397841257984168dc6c1a7ab76233/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/7d73f29d80a26b6bd2111ed7fc691dec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/063ece8f772e6a616a93505b32876d41/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/e742c20af8e7be2c949fc7cce63de0f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/cb3361e47f5d58d4a0393f6576ddf21e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/41f16b1452a54d78b0af28fa346e0a94/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/9e8b61cef3f8c07db3a96d2191def80a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/559f1d3b394db28f7bbeea2dcb3d36ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
      return 'logos'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) + String('.jpg'))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['SOURCE'] = (['https://pzcoach.lorio.nl/api/files/logos/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'.jpg','?dummy=',(new Date((new Date())).getTime())].join(''));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('559f1d3b394db28f7bbeea2dcb3d36ce');

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  async ['onUploadFail'](___arguments) {
      await new Promise(r => setTimeout(r, 3000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('559f1d3b394db28f7bbeea2dcb3d36ce');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/mijngegevens/components/20c3c9c216c24da6ed187defb2748946/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'SOURCE'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/9d5e92a96cb93068a3d8adb8ebf42a47/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/0615cc02759c0e385f887b013f75e7d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12'), 'factuurkwitantie')) == 'Factuur' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/775c7a8524f6b7aa3e0a745113347624/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('factuurgegevens').save( ___arguments.context.getComponentDataStoreByUid('fd6d3607d19d577aa274efc866933f12') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/mijngegevens/components/cb89fabcf097cc040cfa2cbc41a475ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'btwinclondersteuningpatient')) == 1 ? 'Ja' : 'Nee')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/96e47d7fbc891382fdf50efb5d88178f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'rol')) == 'pzcoach' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/mijngegevens/components/800bdf1108ba4621f0ff8a54603ca6b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d2fe81b9e0d37a81578858bbc0fd05ba'), 'rol')) == 'pzcoach' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/notallowed/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await Backendless.UserService.isValidLogin())) {
    await ( async function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/notallowed/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  } else if (((await Backendless.UserService.getUserRoles()).includes('beheerder')) || ((await Backendless.UserService.getUserRoles()).includes('Lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')).startsWith('lorio'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['filter'] = (['username=\'',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'\'','AND aanmaakmaand=\'',(new Date((new Date())).getMonth() + 1),'\''].join(''));
  await Backendless.Data.of('newuserrequests').bulkUpdate( 'objectId is not null', ({ [`aanmaken`]: false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/permissions/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/67f403196da705f23d86dfac2267d69b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'naam')) == null) {
    (function (message) { alert(message) })('Selecteer naam');
  } else if ((getObjectProperty(___arguments.context.pageData, 'email')) == null) {
    (function (message) { alert(message) })('Selecteer email');
  } else if ((getObjectProperty(___arguments.context.pageData, 'usernameregister')) == null) {
    (function (message) { alert(message) })('Vul username in');
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'pzcoach') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserpzcoach', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
      (function (message) { alert(message) })('De email is verzonden');
    } else if ((getObjectProperty(___arguments.context.pageData, 'rol')) == 'beheerder') {
      await Backendless.Messaging.sendEmailFromTemplate('newuserbeheerder', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
      (function (message) { alert(message) })('De email is verzonden');
    } else {
      await Backendless.Messaging.sendEmailFromTemplate('newuserprojectleden', Backendless.EmailEnvelope.create({ addresses: (getObjectProperty(___arguments.context.pageData, 'email')), ccAddresses: undefined, bccAddresses: ['backendless@lorio.nl'], query: '', uniqueEmails: true }), ({ [`naam`]: (getObjectProperty(___arguments.context.pageData, 'naam')),[`username`]: (getObjectProperty(___arguments.context.pageData, 'usernameregister')),[`organisatie`]: (getObjectProperty(___arguments.context.pageData, 'organisatie')) }), undefined);
      (function (message) { alert(message) })('De email is verzonden');
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3c46bf080591e52937d1171cdf247b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesmnl() {
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('objectId is not null') }).send());
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('declaraties'),'whereClause': JSON.stringify((['username=\'',(getObjectProperty(j, 'username')),'\''].join(''))) }).send());
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`projectcode`]: (getObjectProperty(item, 'projectcode')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.REMOVE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'beheerder\'') }).send());
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties uitgevoerd');
}


  await permissionsdeclaratiesmnl();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/d35d2ecc5053f5d217e97dd6aa67a7fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  await Backendless.Data.of('gebruikersbeheer').bulkDelete( 'objectId is not null' );
  users = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users') }).send());
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`username`]: (getObjectProperty(j, 'username')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`btwplichtig`]: (getObjectProperty(j, 'btwplichtig')),[`rol`]: (getObjectProperty(j, 'rol')),[`tariefkm`]: (getObjectProperty(j, 'tariefkm')),[`tariefuur`]: (getObjectProperty(j, 'tariefuur')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('objectId is not null') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('userStatus=\'ENABLED\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify((String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\''))) }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index2 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index2];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  await ZSD();
  console.log('permissions gebruikersbeheer uitgevoerd');
  (function (message) { alert(message) })('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function ZSD() {
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index3 in userslist2) {
    l = userslist2[l_index3];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('rol=\'ZSD\' OR rol=\'NCZSD\'') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index3 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index3];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  users2 = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Users'),'whereClause': JSON.stringify('rol=\'ZSD\' OR rol=\'NCZSD\'') }).send());
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index4 in userslist2) {
    l = userslist2[l_index4];
    gebruikersbeheer = (await Backendless.Request.get(`${Backendless.appPath}/services/paging/paging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('gebruikersbeheer'),'whereClause': JSON.stringify('username=\'Dnn73mwn\'') }).send());
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index4 in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index4];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
}


  await permissionsgebruikersbeheer();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/a68db61433b22daeb3e3c9beb0d3c9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, userslist2, item, users2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': ' userStatus=\'ENABLED\'','properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
  (function (message) { alert(message) })('permissions users uitgevoerd');
}


  await permissionsusers();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/bfb66cb2f42e8afcf5b28649842d0c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newuser, l, m, gebruikersbeheerlist, item, gebruikersbeheer, userslist2, users2, j, userslist, users, k, dossiers, declaraties;

/**
 * Describe this function...
 */
async function instellen_permissions() {
  await permissionsgebruikersbeheer();
  await permissionsusers();
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsgebruikersbeheer() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['objectId', 'dashboardnaam', 'naam', 'organisatie', 'rol', 'username', 'userStatus', 'lastLogin', 'btwplichtig', 'btwinclondersteuningpatient', 'email'] }));
  userslist = (await Promise.all(users.map(async item => {; return item;})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    await Backendless.Data.of('gebruikersbeheer').save( ({ [`userobjectId`]: (getObjectProperty(j, 'objectId')),[`dashboardnaam`]: (getObjectProperty(j, 'dashboardnaam')),[`naam`]: (getObjectProperty(j, 'naam')),[`organisatie`]: (getObjectProperty(j, 'organisatie')),[`rol`]: (getObjectProperty(j, 'rol')),[`username`]: (getObjectProperty(j, 'username')),[`userStatus`]: (getObjectProperty(j, 'userStatus')),[`lastLogin`]: (getObjectProperty(j, 'lastLogin')),[`btwplichtig`]: (getObjectProperty(j, 'btwplichtig')),[`btwinclondersteuningpatient`]: (getObjectProperty(j, 'btwinclondersteuningpatient')),[`email`]: (getObjectProperty(j, 'email')) }) );
  }
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (String('userStatus=\'ENABLED\'') + String(' AND rol = \'beheerder\'')) }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index in userslist2) {
    l = userslist2[l_index];
    gebruikersbeheer = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'objectId is not null' }));
    gebruikersbeheerlist = (await Promise.all(gebruikersbeheer.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
    for (var m_index in gebruikersbeheerlist) {
      m = gebruikersbeheerlist[m_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'gebruikersbeheer',[`objectId`]: m }));
    }
  }
  console.log('permissions gebruikersbeheer uitgevoerd');
}

/**
 * Describe this function...
 */
async function permissionsusers() {
  users2 = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': (['username=\'',(getObjectProperty(___arguments.context.pageData, 'usernameregister')),'\''].join('')),'properties': ['objectId'] }));
  userslist2 = (await Promise.all(users2.map(async item => {; return (getObjectProperty(item, 'objectId'));})));
  for (var l_index2 in userslist2) {
    l = userslist2[l_index2];
    await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
    await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'Users',[`objectId`]: l }));
  }
  console.log('permissions users uitgevoerd');
}


  ___arguments.context.pageData['spinner'] = true;
  newuser = (await Backendless.UserService.register( new Backendless.User({ 'username': (getObjectProperty(___arguments.context.pageData, 'usernameregister')),'password': 'CVL2022isBegonnen!?','naam': (getObjectProperty(___arguments.context.pageData, 'naam')),'email': (getObjectProperty(___arguments.context.pageData, 'email')),'organisatie': (getObjectProperty(___arguments.context.pageData, 'organisatie')),'rol': (getObjectProperty(___arguments.context.pageData, 'rol')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'tariefpzcoachperuur': (getObjectProperty(___arguments.context.pageData, 'tariefpzcoachperuur')),'tariefdeclaratiesperuur': (getObjectProperty(___arguments.context.pageData, 'tariefdeclaratiesperuur')),'declaraties': (getObjectProperty(___arguments.context.pageData, 'declaraties')),'dossiers': (getObjectProperty(___arguments.context.pageData, 'dossiers')),'btwplichtig': (getObjectProperty(___arguments.context.pageData, 'btwplichtig')),'btwinclondersteuningpatient': (getObjectProperty(___arguments.context.pageData, 'btwinclondersteuningpatient')) }) ));
  await instellen_permissions();
  (function (message) { alert(message) })((['User is geregistreerd: \n',['Username:  ',(getObjectProperty(newuser, 'username')),' \n'].join(''),['Naam: ',(getObjectProperty(newuser, 'naam')),' \n'].join(''),['Email:  ',(getObjectProperty(newuser, 'email')),' \n'].join(''),['Rol:  ',(getObjectProperty(newuser, 'rol')),' \n'].join('')].join('')));
  await Backendless.Data.of('newuserrequests').bulkUpdate( (['naam=\'',(getObjectProperty(newuser, 'naam')),'\''].join('')), ({ [`useraangemaakt`]: true }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));
  ___arguments.context.pageData['spinner'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/05ab59ac7c3b9157ad86d6a130cb67a7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause('dashboardnaam NOT LIKE \'lorio%\'').setProperties('dashboardnaam').setSortBy('dashboardnaam DESC').setPageSize(10)))[0]), 'dashboardnaam'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/permissions/components/9449ebc70bf23e2a1d64b969cf6647d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'hospice')) == 'Transfer bureau' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/permissions/components/543c1647fb91edcf0518d46c37752178/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, j, declaratieslist, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfacturatieadresgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'facturatieadresgegevens','whereClause': 'objectId is not null','properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'rol=\'beheerder\'' }));
      beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var l_index in beheerderslist) {
        l = beheerderslist[l_index];
        await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'facturatieadresgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions facturatieadresgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions facturatieadresgegevens uitgevoerd');
}


  await permissionsfacturatieadresgegevens();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/6c3d7b18c98f6608c648ab78251bce44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, gegevenslist, item, gegevens, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsfactuurgegevens() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'objectId is not null','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    gegevens = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'factuurgegevens','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    gegevenslist = (await Promise.all(gegevens.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in gegevenslist) {
      k = gegevenslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'factuurgegevens',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions factuurgegevens uitgevoerd');
  (function (message) { alert(message) })('permissions factuurgegevens uitgevoerd');
}


  await permissionsfactuurgegevens();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/c3c8692edd7df313d0589228c22790e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;


  var j_list = ['naam', 'email', 'organisatie', 'usernameregister', 'btwplichtig', 'rol', null, null, null, null, null, null];
  for (var j_index in j_list) {
    j = j_list[j_index];
    ___arguments.context.pageData[j] = null;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/f8daf5872d2777cc4a819fead57ce1b7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f8daf5872d2777cc4a819fead57ce1b7', (await Backendless.Data.of('newuserrequests').find(Backendless.DataQueryBuilder.create().setWhereClause('useraangemaakt = 0').setPageSize(10))));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/permissions/components/7622db78b4a8b818b068046e27e81c18/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('newuserrequests').save( ___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58') );
  ___arguments.context.pageData['naam'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'naam'));
  ___arguments.context.pageData['email'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'email'));
  ___arguments.context.pageData['organisatie'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'organisatie'));
  ___arguments.context.pageData['rol'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'rol'));
  ___arguments.context.pageData['tariefdeclaratiesperuur'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'tariefdeclaratiesperuur'));
  ___arguments.context.pageData['tariefpzcoachperuur'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'tariefpzcoachperuur'));
  ___arguments.context.pageData['dossiers'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'dossiers'));
  ___arguments.context.pageData['declaraties'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'declaraties'));
  ___arguments.context.pageData['btwplichtig'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwplichtig'));
  ___arguments.context.pageData['btwinclondersteuningpatient'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('be63a99a2eb2fbf27388987846a84d58'), 'btwinclondersteuningpatient'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/permissions/components/7cef7da404088638c51e3a888e53ae58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, k, declaratieslist, item, declaraties, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsmaandafsluiten() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'rol=\'beheerder\'','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'maandafsluiten','whereClause': 'objectId is not null','properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      await Backendless.Data.Permissions.FIND.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser((getObjectProperty(j, 'objectId')), ({ [`___class`]: 'maandafsluiten',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions maandafsluiten uitgevoerd');
  (function (message) { alert(message) })('permissions maandafsluiten uitgevoerd');
}


  await permissionsmaandafsluiten();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/57c849c81b7887b8300328298235b709/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(await Backendless.UserService.findByRole('beheerder', false, Backendless.DataQueryBuilder.create().setPageSize(100)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/06ae39ec3388491b5458344b5f081e48/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var m, k, zsdbeheerderlist, item, zsdbeheerder, declaratieslist, declaraties, j, userslist, users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratieszsd() {
  users = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'Users','whereClause': 'rol=\'ZSD\' or rol=\'NCZSD\'','properties': ['username', 'objectId'] }));
  userslist = (await Promise.all(users.map(async item => {; return ({ [`username`]: (getObjectProperty(item, 'username')),[`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var j_index in userslist) {
    j = userslist[j_index];
    declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaraties','whereClause': (['username=\'',(getObjectProperty(j, 'username')),'\''].join('')),'properties': ['objectId'] }));
    declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
    for (var k_index in declaratieslist) {
      k = declaratieslist[k_index];
      zsdbeheerder = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'username=\'Dnn73mwn\'' }));
      zsdbeheerderlist = (await Promise.all(zsdbeheerder.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
      for (var m_index in zsdbeheerderlist) {
        m = zsdbeheerderlist[m_index];
        await Backendless.Data.Permissions.FIND.grantForUser(m, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
        await Backendless.Data.Permissions.UPDATE.grantForUser(m, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      }
    }
  }
  console.log('permissions declaraties ZSD uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties ZSD uitgevoerd');
}


  await permissionsdeclaratieszsd();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/permissions/components/3848b36881a8b3d87de847a8dccb6618/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var l, k, beheerderslist, item, beheerders, declaratieslist, declaraties;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function permissionsdeclaratiesbeheerders() {
  declaraties = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'declaraties','whereClause': 'objectId is not null','properties': ['objectId'] }));
  declaratieslist = (await Promise.all(declaraties.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')) });})));
  for (var k_index in declaratieslist) {
    k = declaratieslist[k_index];
    beheerders = (await Backendless.Request.post(`${Backendless.appPath}/services/paging/paging`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'tableName': 'gebruikersbeheer','whereClause': 'rol=\'beheerder\'' }));
    beheerderslist = (await Promise.all(beheerders.map(async item => {; return (getObjectProperty(item, 'userobjectId'));})));
    for (var l_index in beheerderslist) {
      l = beheerderslist[l_index];
      await Backendless.Data.Permissions.FIND.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
      await Backendless.Data.Permissions.UPDATE.grantForUser(l, ({ [`___class`]: 'declaraties',[`objectId`]: (getObjectProperty(k, 'objectId')) }));
    }
  }
  console.log('permissions declaraties beheerder uitgevoerd');
  (function (message) { alert(message) })('permissions declaraties beheerder uitgevoerd');
}


  await permissionsdeclaratiesbeheerders();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setSortBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('Datum activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c61e972ea44d60bf24f273727da2add6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'soort')) == null) {
    (function (message) { alert(message) })('Soort projectkosten dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'kostenplaats')) == null) {
    (function (message) { alert(message) })('Kostenplaats dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('52048d8528aa762cc2b47b9c6f557476')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    (function (message) { alert(message) })('Bedrag excl. btw dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('341dd443b2c419f32d7bbddc56d88001')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    (function (message) { alert(message) })('BTW dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ 'aanmaakdatum': (new Date()),'datum': (getObjectProperty(___arguments.context.pageData, 'datum')),'soort': (getObjectProperty(___arguments.context.pageData, 'soort')),'omschrijving': (getObjectProperty(___arguments.context.pageData, 'omschrijving')),'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'kostenplaats')),'bedragcalc': (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')),'btw': (getObjectProperty(___arguments.context.pageData, 'btw')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'organisatie': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'file': (getObjectProperty(___arguments.context.pageData, 'file')),'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'controle': 'PROJECTKOSTEN','rol': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'invoer': 'projectkosten' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    ___arguments.context.pageData['datum'] = null;
    ___arguments.context.pageData['soort'] = null;
    ___arguments.context.pageData['omschrijving'] = null;
    ___arguments.context.pageData['kostenplaats'] = null;
    ___arguments.context.pageData['bedragexbtw'] = null;
    ___arguments.context.pageData['btw'] = null;
    ___arguments.context.pageData['disablesave'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('3342df5cf51474ded7e42463ff683bb6');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/projectkosten/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginabeheerder', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/3342df5cf51474ded7e42463ff683bb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = (['https://pzcoach.lorio.nl/api/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
      ___arguments.context.pageData['disablesave'] = true;

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  onUploadSuccess(___arguments) {
      ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      ___arguments.context.pageData['disablesave'] = false;

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/projectkosten/components/b63dd5617c0b802d3b6bdfffa8171afa/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'file')) == null ? '' : 'bijlage')

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/projectkosten/components/8fba7ccc73ad762eb6036605780f2255/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalcbtw'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/0af2e266604f9143f7cae657d88abcdc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalctotaal'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/5cc10345685b54b6e559aa9e945fa2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  ___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a')['change'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/5736d87b0cd63d924988b453b0dd4c35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('registratiespzcoach').bulkDelete( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d032df632a81c08ddb540411b2af486a'), 'objectId')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify('invoer=\'projectkosten\''),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/d6ab1a010ef99e6a2728f9ec9fd2249c/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').bulkUpdate( 'invoer=\'projectkosten\'', ({ 'change': false }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/projectkosten/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['jaar'] = '%';
  ___arguments.context.pageData['maand'] = '%';
  ___arguments.context.pageData['soortselect'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify('invoer=\'projectkosten\''),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/projectkosten/components/f9359156faa97e7212ed45a7ccf19bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null && (getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
  } else if ((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) == null) {
    euro = '0';
  } else if ((getObjectProperty(___arguments.context.pageData, 'btw')) == null) {
    euro = '0';
  } else {
    euro = (await (async function(euro) {
    	var result;

    	  if (euro) {
    	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
    	      style: "currency",
    	      currency: "EUR",
    	      })
    	    result=EUcostFormat.format(euro);

    	} else {
    	   result = '€ 0,00';
    	}

    	return result;
    })((((getObjectProperty(___arguments.context.pageData, 'bedragexbtw')) / 100) * (getObjectProperty(___arguments.context.pageData, 'btw')) + (getObjectProperty(___arguments.context.pageData, 'bedragexbtw')))));
  }

  return euro

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/projectkosten/components/1f27ee7f3fbe777dd2310cb662635797/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('abf9fff3bc9e8301f2d122bc2b7be435')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abf9fff3bc9e8301f2d122bc2b7be435', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abf9fff3bc9e8301f2d122bc2b7be435', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/e7ca9196eda7093b486544575e6a92ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('soortprojectkosten').save( ({ 'soort': (getObjectProperty(___arguments.context.pageData, 'toevoegensoort2')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('c61e972ea44d60bf24f273727da2add6', (await Promise.all((await Backendless.Data.of('soortprojectkosten').find(Backendless.DataQueryBuilder.create().setProperties('soort').setSortBy('soort ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });}))));
  ___arguments.context.pageData['toevoegensoort2'] = '';
  (function (message) { alert(message) })('De nieuwe soort is succesvol toegevoegd aan de lijst');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('abf9fff3bc9e8301f2d122bc2b7be435', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('51365b1da4fcbc9bb4c46aac40934e1c', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/bc8266bbe60fa1b653547263603554a9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var euro, part, dotnumber, length2, rest, cent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  euro = (await (async function(euro) {
  	var result;

  	  if (euro) {
  	   let EUcostFormat = Intl.NumberFormat("nl-NL", {
  	      style: "currency",
  	      currency: "EUR",
  	      })
  	    result=EUcostFormat.format(euro);

  	} else {
  	   result = '€ 0,00';
  	}

  	return result;
  })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'bedragcalc'))));

  return euro

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/projectkosten/components/10afb4add8552c53037fb16b87ab42f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d032df632a81c08ddb540411b2af486a')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d032df632a81c08ddb540411b2af486a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/953aca84f40365f4a391a53186fd300f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'projectkosten\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))).setProperties('aanmaakjaar').setSortBy('aanmaakjaar ASC').setGroupBy('aanmaakjaar').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakjaar')),'label': (getObjectProperty(item, 'aanmaakjaar')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/ad35718c4f84ac0a5bc7e9f98a4ffd98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['jaar'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/a2ebd64b89fb09fb4a2214a8a98c6e29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))).setProperties('aanmaakmaandnum').setSortBy('aanmaakmaandnum ASC').setGroupBy('aanmaakmaandnum').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'aanmaakmaandnum')),'label': (getObjectProperty(item, 'aanmaakmaandnum')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/b5bc09a3fe96b5f8581fed9143aded36/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['maand'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/4dcd3141d7e99d938cb9e436d5bbd7be/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\''].join(''))).setProperties('soort').setSortBy('soort ASC').setGroupBy('soort').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'soort')),'label': (getObjectProperty(item, 'soort')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/projectkosten/components/bd416a242bcc7b222fc4a4961b5668e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['soortselect'] = '%';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/268944f95998b2ef8d0bb78f6043aa1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('475f63d88e3bd245e8ab5c96db2f6b41')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/64c39e1f918fa144ed9efc62d647ebee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('475f63d88e3bd245e8ab5c96db2f6b41')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('475f63d88e3bd245e8ab5c96db2f6b41', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/23ec68e36589725d8601ac835f15e1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6a917ad1284f7ad6a7c4f3da784f23e4')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/f2842bec7127ac5755ec311e435e65c9/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oldfileref'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'));

  },
  /* handler:onBeforeUpload */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('kopiescan/') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var extension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  extension = subsequenceFromStartLast((getObjectProperty(___arguments.file, 'name')), (((getObjectProperty(___arguments.file, 'name')).indexOf('.') + 1) - 1));
  await Backendless.Counters.addAndGet('kopiescan', 1);
  ___arguments.context.pageData['file'] = (['https://pzcoach.lorio.nl/api/files/kopiescan/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''));

  return ([(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'-',(await Backendless.Counters.get('kopiescan')),extension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'fileref': (getObjectProperty(___arguments.context.pageData, 'file')),'file': (getObjectProperty(___arguments.context.pageData, 'file')) }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));
  if ((getObjectProperty(___arguments.context.pageData, 'oldfileref')) != null) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'oldfileref'))));
  }
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('f2842bec7127ac5755ec311e435e65c9');

  },
  /* handler:onUploadSuccess */
  /* content */
}))

define('./pages/projectkosten/components/8955ad5e80c16dde2126fe26e1022c9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  try {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'fileref'))));

  } catch (error) {

  }
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8823eba810e6bc7f63bedf576091d8ac'), 'objectId')),'\''].join('')), ({ 'file': null,'fileref': null }) );
  (function (message) { alert(message) })('De bijlage is verwijderd.');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d6ab1a010ef99e6a2728f9ec9fd2249c', (await Backendless.Request.get(`${Backendless.appPath}/services/maandcontrolepaging/maandcontrolepaging`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('registratiespzcoach'),'whereClause': JSON.stringify((['invoer=\'projectkosten\'',' AND aanmaakjaar LIKE\'',(getObjectProperty(___arguments.context.pageData, 'jaar')),'\' AND aanmaakmaandnum LIKE\'',(getObjectProperty(___arguments.context.pageData, 'maand')),'\' AND soort LIKE\'',(getObjectProperty(___arguments.context.pageData, 'soortselect')),'\''].join(''))),'sortBy': JSON.stringify('registratienummer DESC') }).send()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/b4ede4cbf80c61b687ccf9ebd62ed7b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed99bb4cac57fe9b2d488c07edc20ff4')), 'display')) == false) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed99bb4cac57fe9b2d488c07edc20ff4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed99bb4cac57fe9b2d488c07edc20ff4', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/8e0a427c44c291d630488cf1fc1b098e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('projectkostenplaats').save( ({ 'kostenplaats': (getObjectProperty(___arguments.context.pageData, 'toevoegenkostenplaats2')) }) );
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('646c72c5b7de6d7edd5b6d39fc94eb67', (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });}))));
  ___arguments.context.pageData['toevoegenkostenplaats2'] = '';
  (function (message) { alert(message) })('De nieuwe kostenplaats is succesvol toegevoegd aan de lijst');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed99bb4cac57fe9b2d488c07edc20ff4', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/projectkosten/components/646c72c5b7de6d7edd5b6d39fc94eb67/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await Promise.all((await Backendless.Data.of('projectkostenplaats').find(Backendless.DataQueryBuilder.create().setProperties('kostenplaats').setSortBy('kostenplaats ASC').setPageSize(100))).map(async item => {; return ({ 'value': (getObjectProperty(item, 'kostenplaats')),'label': (getObjectProperty(item, 'kostenplaats')) });})))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/registratieconsultatietransformatie/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossierobjectid, tarief, timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('De datum van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47c1362b00419b642796f8dbdb277a66')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprdoelcontact')) == null) {
    (function (message) { alert(message) })('Het doel dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('520ce95af3df257cc3a3ce324cf2f844')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminuten')) == null) {
    (function (message) { alert(message) })('Het aantal werkminuten dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach') {
      tarief = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefpzcoach'));
    } else {
      tarief = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefconsultatietransformatie'))));
    }
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ 'soort': 'Consultatie transformatie','aanmaakdatum': (new Date(timestamp)),'datum': (getObjectProperty(___arguments.context.pageData, 'datum')),'oprdoelcontact': (getObjectProperty(___arguments.context.pageData, 'oprdoelcontact')),'werkminuten': (getObjectProperty(___arguments.context.pageData, 'werkminuten')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'organisatie': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'tarief': tarief,'btwplichtig': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'rol': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'invoer': 'registratie','dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'controle': 'TE CONTROLEREN' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
    await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieconsultatietransformatie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultatietransformatie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultatietransformatie/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieconsultatietransformatie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieconsultatietransformatie/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratiemdo/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossierobjectid, tarief, timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('De datum van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47c1362b00419b642796f8dbdb277a66')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprdoelcontact')) == null) {
    (function (message) { alert(message) })('Het doel dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('520ce95af3df257cc3a3ce324cf2f844')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminuten')) == null) {
    (function (message) { alert(message) })('De werktijd dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach') {
      tarief = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefpzcoach'));
    } else {
      tarief = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefmdo'))));
    }
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ 'soort': 'MDO','aanmaakdatum': (new Date(timestamp)),'datum': (getObjectProperty(___arguments.context.pageData, 'datum')),'oprdoelcontact': (getObjectProperty(___arguments.context.pageData, 'oprdoelcontact')),'werkminuten': (getObjectProperty(___arguments.context.pageData, 'werkminuten')),'oprverslaglegging': (getObjectProperty(___arguments.context.pageData, 'oprverslaglegging')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'organisatie': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'regio': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regio')),'tarief': tarief,'btwplichtig': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'rol': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'invoer': 'registratie','dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'controle': 'TE CONTROLEREN' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
    await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiemdo/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdo/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdo/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiemdo/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiemdo/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossierobjectid, tarief, timestamp, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('De datum van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c61e972ea44d60bf24f273727da2add6')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprsoortcontact')) == null) {
    (function (message) { alert(message) })('Het soort contact dient ingevuld te worden');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).length && (getObjectProperty(___arguments.context.pageData, 'oprdoelcontacttoelichting')) == null) {
    (function (message) { alert(message) })('Doel contact of eventuele opmerking dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('646c72c5b7de6d7edd5b6d39fc94eb67')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == null) {
    (function (message) { alert(message) })('Is de complexiteit veranderd dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('49879c7ba2f19bee66dd8d968c6e5bf3')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')) == null) {
    (function (message) { alert(message) })('Redenen waarom de complexiteit is toegenomen dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1d9159073db7524034aa484b48a109')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')) == null) {
    (function (message) { alert(message) })('Redenen waarom de complexiteit is afgenomen dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea82be114b943b7347b972d9b6a2b83c')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprcomplexiteittoegenomenanders')) == null) {
    (function (message) { alert(message) })('Redenen waarom de complexiteit is toegenomen dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('66625e8b343a4ecfb5f9d43c28ae0d68')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitafgenomenanders')) == null) {
    (function (message) { alert(message) })('Redenen waarom de complexiteit is afgenomen dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('520ce95af3df257cc3a3ce324cf2f844')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenpatient')) == null) {
    (function (message) { alert(message) })('De werktijd met de patient dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('449480f43c3975cff1d2d36f3e0dadce')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenmdo')) == null) {
    (function (message) { alert(message) })('De werktijd MDO dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4ff87a28ce4253ffc9b52a62dbaa06cf')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutenintercollegiaal')) == null) {
    (function (message) { alert(message) })('De werktijd Intercollegiaal dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('26825c519055ad5846fe6a4c01794981')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminutennazorg')) == null) {
    (function (message) { alert(message) })('De werktijd Nazorg met de patient dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach') {
      tarief = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefpzcoach'));
    } else {
      tarief = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefondersteuningpatient'))));
    }
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty(___arguments.context.pageData, 'werkminutenpatient')) != null) {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ [`soort`]: 'Ondersteuning patiënt',[`controle`]: 'TE CONTROLEREN',[`aanmaakdatum`]: (new Date(timestamp)),[`betreft`]: 'Contact met patiënt',[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`oprsoortcontact`]: (getObjectProperty(___arguments.context.pageData, 'oprsoortcontact')),[`oprdoelcontacttoelichting`]: (getObjectProperty(___arguments.context.pageData, 'oprdoelcontacttoelichting')),[`oprdoelcontact`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelcontact')),[`oprcomplexiteitstart`]: (getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')),[`oprredenencomplexiteittoegenomen`]: (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).join(','),[`oprredenencomplexiteitverminderd`]: (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).join(','),[`oprcomplexiteittoegenomenanders`]: (getObjectProperty(___arguments.context.pageData, 'oprcomplexiteittoegenomenanders')),[`oprcomplexiteitafgenomenanders`]: (getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitafgenomenanders')),[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenpatient')),[`oprverslaglegging`]: (getObjectProperty(___arguments.context.pageData, 'oprverslaglegging')),[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`btwinclondersteuningpatient`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclondersteuningpatient')),[`tarief`]: tarief,[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`invoer`]: 'registratie',[`oppatientid`]: (getObjectProperty(___arguments.context.pageData, 'oppatientid')),[`opstarttraject`]: (getObjectProperty(___arguments.context.pageData, 'opstarttraject')),[`opcomplexiteitstart`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitstart')),[`opcomplexiteitingeschat`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschat')),[`opcomplexiteitingeschatanders`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitingeschatanders')),[`optzp`]: (getObjectProperty(___arguments.context.pageData, 'optzp')),[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`verwijzer`]: (getObjectProperty(___arguments.context.pageData, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: (getObjectProperty(___arguments.context.pageData, 'opcomplexiteitgeschatresultaat')),[`omschrijvingactiviteit`]: (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
      dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
      await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werkminutenmdo')) != null) {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ [`soort`]: 'MDO',[`controle`]: 'TE CONTROLEREN',[`aanmaakdatum`]: (new Date(timestamp)),[`betreft`]: 'MDO',[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`oprsoortcontact`]: (getObjectProperty(___arguments.context.pageData, 'oprsoortcontact')),[`oprdoelcontacttoelichting`]: (getObjectProperty(___arguments.context.pageData, 'oprdoelcontacttoelichting')),[`oprdoelcontact`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelcontact')),[`oprcomplexiteitstart`]: undefined,[`oprredenencomplexiteittoegenomen`]: undefined,[`oprredenencomplexiteitverminderd`]: undefined,[`oprcomplexiteittoegenomenanders`]: undefined,[`oprcomplexiteitafgenomenanders`]: undefined,[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenmdo')),[`oprverslaglegging`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`btwinclondersteuningpatient`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclondersteuningpatient')),[`tarief`]: tarief,[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`invoer`]: 'registratie',[`oppatientid`]: (getObjectProperty(___arguments.context.pageData, 'oppatientid')),[`opstarttraject`]: undefined,[`opcomplexiteitstart`]: undefined,[`opcomplexiteitingeschat`]: undefined,[`opcomplexiteitingeschatanders`]: undefined,[`optzp`]: undefined,[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`verwijzer`]: (getObjectProperty(___arguments.context.pageData, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: undefined,[`omschrijvingactiviteit`]: (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
      dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
      await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werkminutenintercollegiaal')) != null) {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ [`soort`]: 'Ondersteuning patiënt',[`controle`]: 'TE CONTROLEREN',[`aanmaakdatum`]: (new Date(timestamp)),[`betreft`]: 'Intercollegiaal contact',[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`oprsoortcontact`]: (getObjectProperty(___arguments.context.pageData, 'oprsoortcontact')),[`oprdoelcontacttoelichting`]: (getObjectProperty(___arguments.context.pageData, 'oprdoelcontacttoelichting')),[`oprdoelcontact`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelcontact')),[`oprcomplexiteitstart`]: undefined,[`oprredenencomplexiteittoegenomen`]: undefined,[`oprredenencomplexiteitverminderd`]: undefined,[`oprcomplexiteittoegenomenanders`]: undefined,[`oprcomplexiteitafgenomenanders`]: undefined,[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutenintercollegiaal')),[`oprverslaglegging`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`btwinclondersteuningpatient`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclondersteuningpatient')),[`tarief`]: tarief,[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`invoer`]: 'registratie',[`oppatientid`]: (getObjectProperty(___arguments.context.pageData, 'oppatientid')),[`opstarttraject`]: undefined,[`opcomplexiteitstart`]: undefined,[`opcomplexiteitingeschat`]: undefined,[`opcomplexiteitingeschatanders`]: undefined,[`optzp`]: undefined,[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`verwijzer`]: (getObjectProperty(___arguments.context.pageData, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: undefined,[`omschrijvingactiviteit`]: (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
      dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
      await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'werkminutennazorg')) != null) {
      ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ [`soort`]: 'Ondersteuning patiënt',[`controle`]: 'TE CONTROLEREN',[`aanmaakdatum`]: (new Date(timestamp)),[`betreft`]: 'Nazorg',[`datum`]: (getObjectProperty(___arguments.context.pageData, 'datum')),[`oprsoortcontact`]: (getObjectProperty(___arguments.context.pageData, 'oprsoortcontact')),[`oprdoelcontacttoelichting`]: (getObjectProperty(___arguments.context.pageData, 'oprdoelcontacttoelichting')),[`oprdoelcontact`]: String(getObjectProperty(___arguments.context.pageData, 'listdoelcontact')),[`oprcomplexiteitstart`]: undefined,[`oprredenencomplexiteittoegenomen`]: undefined,[`oprredenencomplexiteitverminderd`]: undefined,[`oprcomplexiteittoegenomenanders`]: undefined,[`oprcomplexiteitafgenomenanders`]: undefined,[`werkminuten`]: (getObjectProperty(___arguments.context.pageData, 'werkminutennazorg')),[`oprverslaglegging`]: undefined,[`username`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),[`naam`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),[`organisatie`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),[`btwinclondersteuningpatient`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwinclondersteuningpatient')),[`tarief`]: tarief,[`btwplichtig`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),[`email`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),[`rol`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),[`invoer`]: 'registratie',[`oppatientid`]: (getObjectProperty(___arguments.context.pageData, 'oppatientid')),[`opstarttraject`]: undefined,[`opcomplexiteitstart`]: undefined,[`opcomplexiteitingeschat`]: undefined,[`opcomplexiteitingeschatanders`]: undefined,[`optzp`]: undefined,[`dossier`]: (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),[`gemeentewoonplaats`]: (getObjectProperty(___arguments.context.pageData, 'gemeentewoonplaats')),[`activiteit`]: (getObjectProperty(___arguments.context.pageData, 'activiteit')),[`verwijzer`]: (getObjectProperty(___arguments.context.pageData, 'verwijzer')),[`opcomplexiteitgeschatresultaat`]: undefined,[`omschrijvingactiviteit`]: (getObjectProperty(___arguments.context.pageData, 'omschrijvingactiviteit')) }) ));
      await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
      dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
      await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  ___arguments.context.pageData['visible'] = 'oprcontactpatient';
  ___arguments.context.pageData['betreft'] = 'Contact met patiënt';
  ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
  ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('687faa43b127d6fe951efbf3bf1b3753', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['visiblepatient'] = false;
  ___arguments.context.pageData['visiblemdo'] = false;
  ___arguments.context.pageData['visibleintercollegiaal'] = false;
  ___arguments.context.pageData['visiblenazorg'] = false;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/51a5e2c995e278451bb775e31761083d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is toegenomen' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/5fc5363573238a0c5a1edd4701e4a8cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is verminderd' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/c61e972ea44d60bf24f273727da2add6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value != 'Face-to-face contact') {
    ___arguments.context.pageData['reistijd'] = null;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/bb2d339b2846511478d5f9f655a9cf2b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Sociale context is ingewikkelder geworden');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Sociale context is ingewikkelder geworden') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/dd3820717af5bc8ca42b8ecfd4a33de7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Snel verslechterd ziektebeeld');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Snel verslechterd ziektebeeld') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/e45af7668068ff4e57c24d258cadaab3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Snel oplopende symptoomlast');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Snel oplopende symptoomlast') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/1db87a97cc6e11255601fc4e7df5df95/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Onverwachte gebeurtenissen in de omgeving van de patiënt');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Onverwachte gebeurtenissen in de omgeving van de patiënt') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/e7ad007fb5fac33511de939e705bb8b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Acuut optredende fysieke problematiek');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Acuut optredende fysieke problematiek') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/633fffdde9dff48173abb39ca0eec627/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Acuut optredende decompensatie op psychisch gebied');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Acuut optredende decompensatie op psychisch gebied') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/d20b6e93c115814be3b701fe981c59d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')), 'Anders');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('25669c4cc0da587b23bf6c13d9eb6e5a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea82be114b943b7347b972d9b6a2b83c', true);
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteittoegenomen')).indexOf('Anders') + 1) - 1), 1);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('25669c4cc0da587b23bf6c13d9eb6e5a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea82be114b943b7347b972d9b6a2b83c', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/dac2fb62e5ea00da766c26d4e72e28e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Sociale context is verbeterd');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Sociale context is verbeterd') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/05a30c9fa854a6b7e0cd17f52bdac0b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Het ziektebeeld is verbeterd');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Het ziektebeeld is verbeterd') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/9ca565f771aa4cd91ffb463c93dca963/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Afnemende symptoomlast');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Afnemende symptoomlast') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/2e7299c719b2d3a4ff8748cdfc42a393/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Stabiele omgeving rondom de patiënt');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Stabiele omgeving rondom de patiënt') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/afa5f86e627f573828c32493573b6e3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Fysieke problematiek is afgenomen');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Fysieke problematiek is afgenomen') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/bb587802c6deb5e90d4e36d4c79f8c4f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Decompensatie op psychisch gebied is afgenomen');
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Decompensatie op psychisch gebied is afgenomen') + 1) - 1), 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/6d9ca013a676e4685e8a67cea8ff31c9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')), 'Anders');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac34ff2aeae13789dba5f4d29dee6351', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66625e8b343a4ecfb5f9d43c28ae0d68', true);
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).splice((((getObjectProperty(___arguments.context.pageData, 'lijstcomplexiteitverminderd')).indexOf('Anders') + 1) - 1), 1);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ac34ff2aeae13789dba5f4d29dee6351', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('66625e8b343a4ecfb5f9d43c28ae0d68', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/c2cb48ffb74bc4e91d3d34b8c6c9f3d7/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('687faa43b127d6fe951efbf3bf1b3753', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['listdoelcontact'] = [];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/2337727128e2966a5a7f2fea1595ce69/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['oppatientid'] = (getObjectProperty(___arguments.context.dataModel, 'oppatientid'));
  ___arguments.context.pageData['opstarttraject'] = (getObjectProperty(___arguments.context.dataModel, 'opstarttraject'));
  ___arguments.context.pageData['opcomplexiteitstart'] = (getObjectProperty(___arguments.context.dataModel, 'opcomplexiteitstart'));
  ___arguments.context.pageData['opcomplexiteitingeschat'] = (getObjectProperty(___arguments.context.dataModel, 'opcomplexiteitingeschat'));
  ___arguments.context.pageData['opcomplexiteitingeschatanders'] = (getObjectProperty(___arguments.context.dataModel, 'opcomplexiteitingeschatanders'));
  ___arguments.context.pageData['optzp'] = (getObjectProperty(___arguments.context.dataModel, 'optzp'));
  ___arguments.context.pageData['gemeentewoonplaats'] = (getObjectProperty(___arguments.context.dataModel, 'gemeentewoonplaats'));
  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.pageData['verwijzer'] = (getObjectProperty(___arguments.context.dataModel, 'verwijzer'));
  ___arguments.context.pageData['opcomplexiteitgeschatresultaat'] = (getObjectProperty(___arguments.context.dataModel, 'opcomplexiteitgeschatresultaat'));
  ___arguments.context.pageData['omschrijvingactiviteit'] = (getObjectProperty(___arguments.context.dataModel, 'omschrijvingactiviteit'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/49879c7ba2f19bee66dd8d968c6e5bf3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is toegenomen' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/4b1d9159073db7524034aa484b48a109/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is verminderd' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/5c946c2bd1753cfea6e778e65f27eee3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'betreft')) == 'MDO') {
    result = 'Datum MDO:';
  } else {
    result = 'Datum contact:';
  }

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/c3e7843e2aaa037673a359271e2e32c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'betreft')) == 'MDO') {
    result = 'Doel MDO:';
  } else {
    result = 'Doel contact:';
  }

  return result

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/e8bf39cc31f31c07b9ece8df2802e9bf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8bf39cc31f31c07b9ece8df2802e9bf')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e8bf39cc31f31c07b9ece8df2802e9bf')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/759486b52bff266e3a82db3b878f1e7d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('759486b52bff266e3a82db3b878f1e7d')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('759486b52bff266e3a82db3b878f1e7d')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/60bc9bcb47a25ce3ec59e11a5f414f9f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('60bc9bcb47a25ce3ec59e11a5f414f9f')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('60bc9bcb47a25ce3ec59e11a5f414f9f')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/39f961675c8c4153b832f151442a391b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('39f961675c8c4153b832f151442a391b')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('39f961675c8c4153b832f151442a391b')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/085ba41d5bff439baa83c219c4fead93/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('085ba41d5bff439baa83c219c4fead93')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('085ba41d5bff439baa83c219c4fead93')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/15cb0b6845cc9dff8ea11448dee944a8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15cb0b6845cc9dff8ea11448dee944a8')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('15cb0b6845cc9dff8ea11448dee944a8')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/f5640063ad0730220d3e4ce56ff7a59c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f5640063ad0730220d3e4ce56ff7a59c')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f5640063ad0730220d3e4ce56ff7a59c')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/2858b7670cbb8cf51605af74c0f333dd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2858b7670cbb8cf51605af74c0f333dd')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2858b7670cbb8cf51605af74c0f333dd')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/9d2f44438c2150db7f07cd5897a18a85/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d2f44438c2150db7f07cd5897a18a85')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9d2f44438c2150db7f07cd5897a18a85')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/680c5ea3b9b59a0da6c57041f174f45f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('680c5ea3b9b59a0da6c57041f174f45f')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('680c5ea3b9b59a0da6c57041f174f45f')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/617eccbe11ca394fd36b6f7432a30957/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617eccbe11ca394fd36b6f7432a30957')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617eccbe11ca394fd36b6f7432a30957')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/5a1df64b7d562a37dcad40be393ca16c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a1df64b7d562a37dcad40be393ca16c')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a1df64b7d562a37dcad40be393ca16c')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/ee277ab51f3e21f79bc2a3939801ba07/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee277ab51f3e21f79bc2a3939801ba07')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee277ab51f3e21f79bc2a3939801ba07')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/98b4a593b77b4f2ddfda0c4eba346da4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98b4a593b77b4f2ddfda0c4eba346da4')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98b4a593b77b4f2ddfda0c4eba346da4')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/7f092cd9880eeabf549951b61758a168/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f092cd9880eeabf549951b61758a168')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7f092cd9880eeabf549951b61758a168')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/9228fd155e8c7d6d82c4e97426085aab/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9228fd155e8c7d6d82c4e97426085aab')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9228fd155e8c7d6d82c4e97426085aab')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/976385ec20638ea5aef541f52ca9e03d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('976385ec20638ea5aef541f52ca9e03d')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('976385ec20638ea5aef541f52ca9e03d')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/47caf5d39ffb182e3ef61b0f6b83663a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function visibility() {
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Besluitvorming op meerdere domeinen ten aanzien van onderstaande')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling 1e lijn ter voorkoming behandeling 2 lijn')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie ziekte gericht naar symptoomgerichte palliatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Transitie symptoomgericht naar stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies fysiek domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/interventies psychisch domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Interventies sociaal domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Symptoom behandeling/ interventies existentieel en spiritueel domein')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Scenario denken en voorlichting aan patiënten/naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Stervensfase')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Medicatiereview en saneren van medicatie')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Begeleiding naasten')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Proactieve zorgplanning')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Doorverwijzen')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Behandeling APU')) {
    ___arguments.context.pageData['visiblepatient'] = true;
  } else {
    ___arguments.context.pageData['visiblepatient'] = false;
    ___arguments.context.pageData['oprdoelcontact'] = null;
    ___arguments.context.pageData['oprcomplexiteitstart'] = null;
    ___arguments.context.pageData['oprcomplexiteittoegenomenanders'] = null;
    ___arguments.context.pageData['lijstcomplexiteittoegenomen'] = [];
    ___arguments.context.pageData['lijstcomplexiteitverminderd'] = [];
    ___arguments.context.pageData['oprcomplexiteitafgenomenanders'] = null;
    ___arguments.context.pageData['werkminutenpatient'] = null;
    ___arguments.context.pageData['oprverslaglegging'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('MDO')) {
    ___arguments.context.pageData['visiblemdo'] = true;
  } else {
    ___arguments.context.pageData['visiblemdo'] = false;
    ___arguments.context.pageData['werkminutenmdo'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Intercollegiaal contact')) {
    ___arguments.context.pageData['visibleintercollegiaal'] = true;
  } else {
    ___arguments.context.pageData['visibleintercollegiaal'] = false;
    ___arguments.context.pageData['werkminutenintercollegiaal'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).includes('Nazorg/rouw en verlies behandeling')) {
    ___arguments.context.pageData['visiblenazorg'] = true;
  } else {
    ___arguments.context.pageData['visiblenazorg'] = false;
    ___arguments.context.pageData['werkminutennazorg'] = null;
  }
}


  if (___arguments.value == true) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47caf5d39ffb182e3ef61b0f6b83663a')), 'label')));
  } else if (___arguments.value == false) {
    (getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).splice((((getObjectProperty(___arguments.context.pageData, 'listdoelcontact')).indexOf(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47caf5d39ffb182e3ef61b0f6b83663a')), 'label')) + 1) - 1), 1);
  }
  await visibility();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/c0db2867755bfb151826ec8960d8422c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblepatient'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/a22212cda7ff3d983f5616c8b881fef9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblepatient'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/646c72c5b7de6d7edd5b6d39fc94eb67/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblepatient'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/277d8b7c785b43a6efafceb9a5d9d188/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblemdo'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/449480f43c3975cff1d2d36f3e0dadce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblemdo'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/6e7e875865f7824e371fd6c877bdfdc7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibleintercollegiaal'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/4ff87a28ce4253ffc9b52a62dbaa06cf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibleintercollegiaal'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/09949c89005f610c2913c5872de20853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblenazorg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/26825c519055ad5846fe6a4c01794981/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblenazorg'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/520ce95af3df257cc3a3ce324cf2f844/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblepatient'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/25669c4cc0da587b23bf6c13d9eb6e5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is toegenomen' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/ea82be114b943b7347b972d9b6a2b83c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is toegenomen' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/ac34ff2aeae13789dba5f4d29dee6351/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is verminderd' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/66625e8b343a4ecfb5f9d43c28ae0d68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'oprcomplexiteitstart')) == 'De complexiteit is verminderd' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/a971693f3d7eab5eedf4e406af97f164/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblepatient'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratieondersteuningpatient/components/3d1d087c6d65cd3d70fc59815ad9ca5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visiblepatient'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registratiesupervisie/components/ec6ed7bab785b0eb033be9b7d1040f5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dossierobjectid, tarief, timestamp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2c935f216085692a30788fa699be4e1')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'datum')) == null) {
    (function (message) { alert(message) })('De datum van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47c1362b00419b642796f8dbdb277a66')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'oprdoelcontact')) == null) {
    (function (message) { alert(message) })('Het doel van de activiteit dient ingevuld te worden');
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('520ce95af3df257cc3a3ce324cf2f844')), 'display')) == true && (getObjectProperty(___arguments.context.pageData, 'werkminuten')) == null) {
    (function (message) { alert(message) })('De werktijd dient ingevuld te worden');
  } else {
    ___arguments.context.pageData['disablesave'] = true;
    timestamp = ((new Date()).valueOf());
    if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')) == 'pzcoach') {
      tarief = (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'tariefpzcoach'));
    } else {
      tarief = (JSON.parse((getObjectProperty(___arguments.context.appData, 'tariefsupervisie'))));
    }
    ___arguments.context.pageData['createdrecord'] = (await Backendless.Data.of('registratiespzcoach').save( ({ 'soort': 'Supervisie','aanmaakdatum': (new Date(timestamp)),'datum': (getObjectProperty(___arguments.context.pageData, 'datum')),'oprdoelcontact': (getObjectProperty(___arguments.context.pageData, 'oprdoelcontact')),'werkminuten': (getObjectProperty(___arguments.context.pageData, 'werkminuten')),'username': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'organisatie': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'organisatie')),'regio': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'regio')),'tarief': tarief,'btwplichtig': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'btwplichtig')),'email': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'rol': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'rol')),'invoer': 'registratie','dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'controle': 'TE CONTROLEREN' }) ));
    await Backendless.Data.of('Users').addRelation((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), 'userregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    dossierobjectid = (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('objectId').setPageSize(10)))[0];
    await Backendless.Data.of('dossiers').addRelation(dossierobjectid, 'dossierregistraties', [(getObjectProperty(___arguments.context.pageData, 'createdrecord'))]);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'disablesave')) == true ? true : false)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/registratiesupervisie/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiesupervisie/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiesupervisie/components/b63c7f7325b6bc2cd96ad1f5a1228c75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (message) { alert(message) })([(getObjectProperty(___arguments.context.pageData, 'uren')), (getObjectProperty(___arguments.context.pageData, 'kilometers')), (getObjectProperty(___arguments.context.pageData, 'bedrag')), (getObjectProperty(___arguments.context.pageData, 'bedragtitel')), (getObjectProperty(___arguments.context.pageData, 'bedragomschrijving'))]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registratiesupervisie/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registratiesupervisie/components/b2c935f216085692a30788fa699be4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  date = (new Date((getObjectProperty(___arguments.context.pageData, 'datum'))));
  date.setHours(12);
  date.setMinutes(0);
  date.setSeconds(0);
  date.setSeconds(0);
  ___arguments.context.pageData['datum'] = (date.valueOf());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('mijndossiers', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9f4184d819264e12cd2590f12836d264', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a6acaff68a371d2abdb39730aa4362a', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('f7f56147fec85f84f86cf94f5186a1cd', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties('username').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cd09af1422e4dcba15ac9dafad8b5852', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7259e1186c782b45bfbca3b584ea819b', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a5b9b324c861715743512cc5235acfc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['Sum(werkminuten) as werkminuten', 'Sum(kilometers) as kilometers', 'Count(dossier) as aantalconsulten']).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/startconsult/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('DOSSIER ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/1ee787e67bd36365508cf9c956cad106/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/3d6e7132a80fd6eeb159b661c379d89a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.appData['dossierobjectId'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));

  return ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ondersteuning patiënt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.dataModel, 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/70a5aa5f3987dea7f95bd467eb7d68f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));

  return ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.dataModel, 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/70bf5d146515d53d40213163efb48c9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));

  return ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Supervisie' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.dataModel, 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/d6c5a30f1365f30ad103fd9a7a0b7e7e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));
  ___arguments.context.appData['activiteit'] = (getObjectProperty(___arguments.context.dataModel, 'activiteit'));

  return ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consultatie transformatie' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['dossierstatus'] = (getObjectProperty(___arguments.context.dataModel, 'status'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/feb3fe6f59e9fc8ed57fa245ace9424d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (new Intl.DateTimeFormat('nl', undefined).format((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3d6e7132a80fd6eeb159b661c379d89a'), 'opstarttraject'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/6ae53d388db66246fa0da4b2dfa40729/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ondersteuning patiënt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieondersteuningpatient', undefined);
  } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'MDO') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdo', undefined);
  } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Supervisie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiesupervisie', undefined);
  } else if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Consultatie transformatie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultatietransformatie', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Actief')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/1886ecfe126e2f1bc848da812c7538ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'Ondersteuning patiënt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieondersteuningpatient', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'MDO') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdo', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'Supervisie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiesupervisie', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'Consultatie transformatie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultatietransformatie', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/3233e7144b17379b0c4363bdf4abd0bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'Ondersteuning patiënt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieondersteuningpatient', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'MDO') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiemdo', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'Supervisie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratiesupervisie', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6ae53d388db66246fa0da4b2dfa40729'), 'activiteit')) == 'Consultatie transformatie') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registratieconsultatietransformatie', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/50b840c238ceb6ba11136f3403757144/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['dossierusername'] = (getObjectProperty(___arguments.context.dataModel, 'username'));

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/startconsult/components/a55cd765fdd3cd09b6bad9b897ef5379/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/dbf9f8f17825714d2771b87e8b4fa56b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/2c7ca77a22cee9c4c82718bb0fcd4635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('dossierdelen', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/e4fb4d1aa7ed5a574631da46bb1e9a66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'activiteit')) == 'Ondersteuning patiënt') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossieroverige', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? false : true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/127125a8d7543ce2e6f4945e91774fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('afsluitendossier', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/f30d17bd3b8b14322eedcbb3854a1826/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/392b5ec74c0ce0eaab46d38bb4f9f72d/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ [`change`]: false }) );

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/startconsult/components/10a10325dc95464f3ae863819bd46cdc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a774542c5c558cfa5bb37223720ff3cf')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a774542c5c558cfa5bb37223720ff3cf', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a774542c5c558cfa5bb37223720ff3cf', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/614d1ec5711b45687655cf0240e1e339/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('a774542c5c558cfa5bb37223720ff3cf') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/d35e2e6db63206251767c255ebddf906/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'controle')) == 'Akkoord' ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'change')) == true ? false : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'username')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')) ? true : false)))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'objectId')),'\''].join('')), ({ 'change': false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'change')) != true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8b33c5c0fef98b91482a1899078ea02', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('995b313311edfe5b61e12e91964f5561', true);
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'objectId')),'\''].join('')), ({ 'change': true }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec1f9ec6bed47a57b8944f7a85080f77', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('80ad493e1d0660fb8a5b296ff3fb1228', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d35e2e6db63206251767c255ebddf906', false);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'change')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8b33c5c0fef98b91482a1899078ea02', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('995b313311edfe5b61e12e91964f5561', false);
    await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'objectId')),'\''].join('')), ({ 'change': false }) );
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec1f9ec6bed47a57b8944f7a85080f77', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('80ad493e1d0660fb8a5b296ff3fb1228', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d35e2e6db63206251767c255ebddf906', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/80ad493e1d0660fb8a5b296ff3fb1228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d35e2e6db63206251767c255ebddf906', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('80ad493e1d0660fb8a5b296ff3fb1228', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec1f9ec6bed47a57b8944f7a85080f77', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a5b9b324c861715743512cc5235acfc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['Sum(werkminuten) as werkminuten', 'Sum(kilometers) as kilometers', 'Count(dossier) as aantalconsulten']).setPageSize(100))));
  await Backendless.Data.of('registratiespzcoach').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'objectId')),'\''].join('')), ({ 'change': false }) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c8b33c5c0fef98b91482a1899078ea02', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('995b313311edfe5b61e12e91964f5561', false);
  (function (message) { alert(message) })('Wijziging is opgeslagen');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/ec1f9ec6bed47a57b8944f7a85080f77/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42380a29e02d69412568a1c7d3289c24')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('42380a29e02d69412568a1c7d3289c24', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('42380a29e02d69412568a1c7d3289c24', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/a0f259ede41aa35de5743b14392d54f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('registratiespzcoach').bulkDelete( (['registratienummer=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('42380a29e02d69412568a1c7d3289c24'), 'registratienummer')),'\''].join('')) );
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('42380a29e02d69412568a1c7d3289c24', false);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9a5b9b324c861715743512cc5235acfc', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setProperties(['Sum(werkminuten) as werkminuten', 'Sum(kilometers) as kilometers', 'Count(dossier) as aantalconsulten']).setPageSize(100))));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', null);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('392b5ec74c0ce0eaab46d38bb4f9f72d', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setSortBy('registratienummer DESC').setPageSize(100))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/440cbc1153294cc78f5f922edaa2ed9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('42380a29e02d69412568a1c7d3289c24', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/5dfef5d8fa1cf96956587385e9f89e0a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/41e24c39f262615380374477c4ba4c75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97') );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/0f02e8d225e1fd4b9a68b8079692fb05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'username')) == (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))) {
    ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'registratienummer'))));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'Ondersteuning patiënt') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieondersteuningpatient', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'Supervisie') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiesupervisie', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'MDO') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiemdo', undefined);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'Consultatie transformatie') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultatietransformatie', undefined);
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'username')) != (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username'))) {
      ___arguments.context.appData['registratienummer'] = (JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'registratienummer'))));
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'Ondersteuning patiënt') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieondersteuningpatient', undefined);
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'Supervisie') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiesupervisie', undefined);
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'MDO') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratiemdo', undefined);
      } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b2335186cd2d94df411502de3d380a97'), 'soort')) == 'Consultatie transformatie') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('detailsregistratieconsultatietransformatie', undefined);
      }
      if (false) {
        (function (message) { alert(message) })('Deze registratie kunt u niet inzien. Deze registratie is door een andere gebruiker waarmee het dossier is gedeeld ingevoerd.');
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/800bece945819b94600c0407ef49e155/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7259e1186c782b45bfbca3b584ea819b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91db479930ba56ff04fbb2a7b6ceff5e', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/76aa22e61662a6ae7dc90edad4e98472/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').save( ___arguments.context.getComponentDataStoreByUid('cdada4539f16dfbf5f227eefdb750e3d') );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9f4184d819264e12cd2590f12836d264', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(50))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/startconsult/components/e1798349cd1f35fe3c11469bb93acfe9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7259e1186c782b45bfbca3b584ea819b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/3cf53c16a371a1fdc756748d62764366/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91db479930ba56ff04fbb2a7b6ceff5e', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/2f04ea3222c25bacee840726769a0be9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'emailtext')) == null) {
    (function (message) { alert(message) })('Er is geen tekst ingevuld om te verzenden via mail.');
  } else {
    await Backendless.Messaging.sendEmailFromTemplate('dossierregistratieaanpassing', Backendless.EmailEnvelope.create({ addresses: 'info@lorio.nl', ccAddresses: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')), bccAddresses: undefined, query: '', uniqueEmails: true }), ({ 'naam': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'naam')),'gebruiker': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'username')),'centraname': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'centraname')),'email2': (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')),'emailtext': (getObjectProperty(___arguments.context.pageData, 'emailtext')),'dossier': (JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))) }), undefined);
    ___arguments.context.pageData['emailtext'] = ('De email is verzonden'.toUpperCase());
    await new Promise(r => setTimeout(r, 3000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91db479930ba56ff04fbb2a7b6ceff5e', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/9076cdc6bc4c747b1727ba5ce19176a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('91db479930ba56ff04fbb2a7b6ceff5e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7259e1186c782b45bfbca3b584ea819b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/fda451f40d2e7317f81431fbfb0f5368/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7259e1186c782b45bfbca3b584ea819b', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/c2e2d59ec3154f22a36a5acafb696d02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('verslaglegging', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/5346acee8fc96dcc606dad3b91f83b0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'dossierstatus')) == 'Afgesloten' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await Backendless.Data.of('dossiers').bulkUpdate( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')), ({ 'status': 'Actief' }) );
  await Backendless.Data.of('dossiersafgesloten').bulkDelete( (['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join('')) );
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9f4184d819264e12cd2590f12836d264', (await Backendless.Data.of('dossiers').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(10))));
  ___arguments.context.pageData['dossierstatus'] = 'Actief';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5346acee8fc96dcc606dad3b91f83b0e', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1ee787e67bd36365508cf9c956cad106', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e4fb4d1aa7ed5a574631da46bb1e9a66', true);
  (function (message) { alert(message) })('Het dossier wordt geopend');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/startconsult/components/08f27a251bab49dff9b4e45afced4b08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'activiteit')) == 'Ondersteuning patiënt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/startconsult/components/d75b246d2ef7d7dd0007425ab659588d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'activiteit')) == 'Ondersteuning patiënt' ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/verslaglegging/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!((await Backendless.UserService.getUserRoles()).includes('pzcoach'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('notallowed', undefined);
  }
  if (!(await Backendless.UserService.isValidLogin())) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('inlogpagina', undefined);
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('76f77f53dadd8c3ab96d280642ca8207', (await Backendless.Data.of('registratiespzcoach').find(Backendless.DataQueryBuilder.create().setWhereClause((['dossier=\'',(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))),'\''].join(''))).setPageSize(100))));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/verslaglegging/components/da41d212ae6863d38204da52c1b9e1f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('startconsult', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/verslaglegging/components/f9fe51eeb3c7a45d74551f98e3b8b37e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if ((await Backendless.UserService.getUserRoles()).includes('pzcoach')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('hoofdpaginagebruiker', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/verslaglegging/components/0bee66f48ffc74c7a116d0f800fed66f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('VERSLAGLEGGING DOSSIER  ') + String(JSON.parse((getObjectProperty(___arguments.context.appData, 'dossier')))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/verslaglegging/components/d9bf204fc0f2ac457fe9699af16d6bdc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await Backendless.Data.of('registratiespzcoach').save( ___arguments.context.dataModel );

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/verslaglegging/components/5ecc5ca9100b7ee189c776ecddea8e9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#A52019';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53'), 'readOnly')) == false) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5ecc5ca9100b7ee189c776ecddea8e9c'))['color'] = '#89b087';
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/verslaglegging/components/19bfb0d80cbc61cf8e036ba2374cdc98/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('8b37c97f55eb463acf09397c71b1ed53')['readOnly'] = true;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/verslaglegging/components/89efc196401e5c994d4813a164a97b83/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf8f4708c3b4a1abab6788f4147ed914', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  await (async function() {
  	window.print()
  })();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf8f4708c3b4a1abab6788f4147ed914', true);

  },
  /* handler:onClick */
  /* content */
}))

